import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { processColumns, processData } from "./processData";
import moment from "moment";
import {
    convertToPercent, round, getRestrictionsArray, getFromSession,
    getFromState, getTransformedSegments, numberFormatForReport, truncate, preferredOrder,
    sortStringArray, deepCopy, processColumnsNew, getAppData, getCompsetName, generateTable, isDateInRange, formattedCompDateCalc,
    dateFormat, in_array, getPermissions, downloadcsvwithTable, getSeriesById, showSegmentType, getUnique, getCorrectValue, shouldShowAutoScroll,
    getMatchedElements,
    updateSessionObject,
    getTileKey,
    getColumnAsOfDate
} from "../../app/util"
import { transformSegmentData } from "./segmentedData";
import { useDownloadExcel } from 'react-export-table-to-excel';
import "./table-reports.css";

import { updateAppState } from "../../actions/appstate";
import { Button, Tooltip, getTableSortLabelUtilityClass, IconButton, Popover, Alert, AlertTitle } from "@mui/material";
import dataService from "../../services/data.service";
import { Box } from "@mui/system";
import { marketSellRatesTotal } from "./tilesData/marketsellrates";
import TableToExcel from "@linways/table-to-excel";
import Spinner from "../Spinner";
import { format, parse } from "date-fns";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import Filter from "./Filter";
import { TILES } from "../../app/config";
import { DRAG_ICON_DISABLED_TILES } from "../../app/config-v4-api";
import Restrictions, { getResName } from "./Restrictions";
import { primaryHeaderDisplay } from './table-functions';
import RoomTypeFilter from './RoomTypeFilter';
import ReportFilter from './ReportFilter';
import { processDataReports } from './processDataReports';
import { getColumnName_revpar } from './tilesData/revpar_index_report_functions';
import { getColumnName_biSensitivity } from './tilesData/bi_sensitivity_report_functions';
import AirportCodes from '../Workspace/subComponents/leftComponents/AirportCodes';
import DisplayData from './DisplayData';
import DisplayDataLogs from './DisplayDataLogs';
import VCapIndicator from './VCapIndicator';
import { generalizeData, otbTransformTotal } from './functions';
import { getRatePlan, getRoomClass, getRoomType, getTopSegments } from './SearchFilter';
import { UPDATE_STATE } from '../../actions/types';
import { TableVirtuoso } from 'react-virtuoso'
// import { dateFormat } from 'highcharts';
import _ from "lodash";


const PrimaryHeaderCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#606060",
        color: "white",
        borderRight: "1px solid white",
        textTransform: "uppercase",
        fontWieght: "700",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 16,
    },
}));
const SecondaryHeaderGreyCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#b2b2b2",
        color: "white",
        borderRight: "1px solid white",
        textTransform: "uppercase",
        fontWieght: "700",
        textAlign: "center",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
const SecondaryHeaderBlueCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#3fa7cd",
        color: "white",
        borderRight: "1px solid white",
        textTransform: "uppercase",
        fontWieght: "700",
        textAlign: "center",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 16,
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
        backgroundColor: "#ebebeb",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));



function downloadReportToExcel(exportFileName, name, table) {

    TableToExcel.convert(table, {
        name: exportFileName + ".xlsx",
        sheet: {
            name: name.toUpperCase()
        }
    });
}

function TableReports({ compDisplayData }) {
    // debugger;
    const state = useSelector(appState => appState);

    const { auth, app } = useSelector(state => state);
    const { profile } = auth;
    const { app_state, ui_state } = useSelector(
        (state) => state.app.current_state
    );
    const { workspace_controls, eventList, eventListSDLY } = app_state;
    const { sdlyOn, segmented_view } = workspace_controls;

    if (ui_state.active_tiles[0] === "revpar_index") {
        compDisplayData = [compDisplayData];
    }
    let savedUserPreferences = profile?.column_preferences;

    const { active_tiles, table_filters } = ui_state;
    let selectedPropertyName = profile.property_details.filter(property => property.id == app_state.property_id)[0].name;
    const active_tiles_className =
        "tile-active-" + ui_state.active_tiles.join(" tile-active-");
    const [columns, setColumns] = useState([]);
    const [data_cols, setDataCols] = useState([]);
    const [data_setup, setDataSetup] = useState([]);
    const dispatch = useDispatch();
    const [displayData, setDisplayData] = useState(compDisplayData);
    const [compLoad, setCompLoad] = useState(false);
    let [reloadGrid, setReloadGrid] = useState("");
    let [compLoadStatus, setCompLoadStatus] = useState('loading');
    const [renderBodyData, setRenderBodyData] = useState([]);
    let [filteredSegments, setFilteredSegments] = useState(['all']);
    let segments = null
    let marketSegments = getFromState('system_settings>market_segment_category_mapping', state);
    let segment_ignore_codes = getFromState('system_settings>market_code_ignorelist', state);
    segments = getTransformedSegments(marketSegments, segment_ignore_codes);
    const tableVirtuoso = useRef(null);
    const [isAtBottom, setIsAtBottom] = useState(false);
    // debugger;

    let filteredDow = table_filters.table_reports.dow.map(d => d.code);
    let segmentType = app_state.workspace_controls.segmentType;
    if (segmentType === 'hotel' && segmented_view) {
        segmentType = "market_segment";
    }

    // if (filteredSegments && filteredSegments.includes('all')) {
    //     let segmentArr = segments.list
    //     if (segmentType === "room_class") {
    //         segmentArr = getRoomClass();
    //         // debugger;
    //     } else if (segmentType === "rate_plan") {
    //         segmentArr = getRatePlan();
    //     } else if (segmentType === "room_type") {
    //         segmentArr = getRoomType();
    //     }
    //     segmentArr = segmentArr.map(v => ({ ...v, hidden: false, title: v.name, type: "reports_segments" }))
    //     ui_state.table_filters.table_reports[segmentType] = segmentArr;
    //     filteredSegments = segmentArr.map(d => d.name);
    // }


    // debugger;
    const showVariableCapacity = !!(
        ui_state.showVariableCapacity &&
        getPermissions(auth.profile.property_details, app_state.property_id).permissions?.variable_capacity_enabled
    );
    const getNeededColumns = ({ auth, app_state, ui_state }) => {
        const { workspace_controls, as_of_date } = app_state;
        let { sdlyOn, pickUpType, segmented_view } = workspace_controls;
        const { active_tiles } = ui_state;
        let startDate = app_state.primary_stay_range.date_from;
        let endDate = app_state.primary_stay_range.date_until;
        let restrictions = (getAppData(auth, app_state).restrictions) ? getAppData(auth, app_state).restrictions.enable : false;
        let finalColumns = [];
        active_tiles.map((tile, i) => {
            let tableConfig = deepCopy(TILES[tile]['tableConfig']);
            let columns = tableConfig['columns'];

            if (ui_state.active_tiles[0] === "revpar_index") {
                columns = (app_state.workspace_controls.tableType === "monthly") ? tableConfig['columns'] : tableConfig['dailycolumns'];
            }

            let sdlyColumns = deepCopy(TILES[tile]['tableConfig']['sdlyOn_columns']);
            let restrictionsColumns = deepCopy(TILES[tile]['tableConfig']['restrictionsOn_columns']);
            let dataDbaColumns = deepCopy(TILES[tile]['tableConfig']['dataDbaColumns']);
            let dataDateColumns = deepCopy(TILES[tile]['tableConfig']['dataDateColumns']);
            let dbaSdlyColumns = deepCopy(TILES[tile]['tableConfig']['dbaOn_sdly_columns']);
            let userForecastColumns = deepCopy(TILES[tile]['tableConfig']['userForecast_columns']);

            finalColumns = [...finalColumns, ...columns];
            //  debugger;
            let tile_segmented_view = true;
            let segmentedViewIgnore = ['compset'];
            if (segmentedViewIgnore.includes(active_tiles[0])) {
                tile_segmented_view = false;
            }
            if (active_tiles[0] === "market" && app_state.workspace_controls.scopeType === 'Dba') {
                tile_segmented_view = false;
            }
            if (active_tiles[0] === "productionMarketReport" || active_tiles[0] === "productionReport") {
                tile_segmented_view = true;
                segmented_view = true
            }

            if (active_tiles[0] === "compset") {
                let subColumns = getCompsetName();
                columns[1]['subcolumns'] = [...columns[1]['subcolumns'], ...subColumns];
            }

            if (active_tiles[0] === "revpar_index") {
                let subColumns = getColumnName_revpar('', app_state);
                columns[1]['subcolumns'] = [...columns[1]['subcolumns'], ...subColumns];
            }

            if (active_tiles[0] === "bi_sensitivity_analysis") {
                let biSensitivityColumns = getColumnName_biSensitivity('', app_state);
                finalColumns = [...finalColumns, ...biSensitivityColumns];
            }

            // check Scope is DBA
            if (dataDbaColumns && app_state.workspace_controls.scopeType === 'Dba' && active_tiles[0] !== "bi_sensitivity_analysis") {
                let dateColIndex = columns.findIndex(item => item.type === "dateColumn");
                let dbaSubColumns = columns[dateColIndex].subcolumns_dba;
                columns[dateColIndex]['subcolumns'] = dbaSubColumns;
                if (dataDbaColumns) {
                    finalColumns = [...finalColumns, ...dataDbaColumns];
                }
            } else {
                if (dataDateColumns) {
                    finalColumns = [...finalColumns, ...dataDateColumns];
                }
            }
            /// end ///

            /// to check user forecast ///
            let userForecastData = [];
            if (!dataService.getSeriesById("ManualForecast").data) {
                userForecastData = [];
            } else {
                userForecastData = dataService.getSeriesById("ManualForecast").data.data;
            }
            if (userForecastData.length > 0 && userForecastColumns) {
                finalColumns = [...finalColumns, ...userForecastColumns];
            }
            //// end ///

            if (sdlyOn && sdlyColumns) {
                finalColumns = [...finalColumns, ...sdlyColumns];
            }
            if (restrictions && restrictionsColumns) {
                finalColumns = [...finalColumns, ...restrictionsColumns];
            }
            if (segmented_view && tile_segmented_view) {
                let dateColIndex = columns.findIndex(item => item.type === "dateColumn");
                let dateColumn = columns[dateColIndex];
                if (dateColIndex > -1 && dateColumn["subcolumns_segmented"]) {
                    dateColumn["subcolumns_segmented"].map(segmented => {
                        columns[dateColIndex].subcolumns.push(segmented);
                    });
                }
            }

            const activeTile = ui_state.active_tiles[0];
            const tileName = getTileKey(activeTile, app_state.workspace_controls, app_state.property_id);

            if (app_state.workspace_controls.sdlyOn && sdlyColumns && sdlyColumns.length) {
                if (savedUserPreferences && savedUserPreferences[tileName] && savedUserPreferences[tileName]['tableConfig'] && savedUserPreferences[tileName]['tableConfig']['columns']) {
                    const savedColIds = new Set(savedUserPreferences[tileName]['tableConfig']['columns'].map(col => col.id));
                    const missingSdlyCols = sdlyColumns.filter(col => !savedColIds.has(col.id));
                    if (missingSdlyCols.length) {
                        savedUserPreferences[tileName]['tableConfig']['columns'] = [
                            ...savedUserPreferences[tileName]['tableConfig']['columns'],
                            ...missingSdlyCols
                        ];
                    }
                }
            }

            if (sdlyOn && dbaSdlyColumns && app_state.workspace_controls.scopeType === 'Dba' && in_array(active_tiles, ["market"])) {
                if (savedUserPreferences && savedUserPreferences[tileName] && savedUserPreferences[tileName]['tableConfig'] && savedUserPreferences[tileName]['tableConfig']['columns']) {
                    const savedColIds = new Set(savedUserPreferences[tileName]['tableConfig']['columns'].map(col => col.id));
                    const missingSdlyCols = dbaSdlyColumns.filter(col => !savedColIds.has(col.id));
                    if (missingSdlyCols.length) {
                        savedUserPreferences[tileName]['tableConfig']['columns'] = [
                            ...savedUserPreferences[tileName]['tableConfig']['columns'],
                            ...missingSdlyCols
                        ];
                    }
                }
            }


            let updatedColumns;
            if (in_array(ui_state.active_tiles, ['bi_sensitivity_analysis'])) {
                // Always keep finalColumns as-is, but apply saved subcolumn ordering from the
                // first saved data column (index 0) to all columns — since all data columns
                // share the same subcolumn order in this tile.
                // Priority: session storage first (latest drag order), then savedUserPreferences (server-saved).
                let columsData = JSON.parse(getFromSession('user_temp_preferences'));
                const savedCols = (columsData && columsData[tileName] && columsData[tileName]['tableConfig'])
                    ? columsData[tileName]['tableConfig']['columns']
                    : (savedUserPreferences && savedUserPreferences[tileName] && savedUserPreferences[tileName]['tableConfig'])
                        ? savedUserPreferences[tileName]['tableConfig']['columns']
                        : null;
                if (savedCols && savedCols.length) {
                    const firstSavedDataCol = savedCols.find(col => col.type !== 'dateColumn');
                    updatedColumns = finalColumns.map(col => {
                        if (col.type === 'dateColumn' || !firstSavedDataCol) return col;
                        // After processColumnsNew, orders are always renumbered 1,2,3...
                        // so copying order numbers by index is meaningless.
                        // Instead, build a value->order map from the saved array's POSITION
                        // (array index = visual order) and apply by value match.
                        const valueOrderMap = {};
                        const valueHiddenMap = {};
                        firstSavedDataCol.subcolumns.forEach((sub, idx) => {
                            valueOrderMap[sub.value] = idx + 1;
                            valueHiddenMap[sub.value] = !!sub.hidden;
                        });
                        const newSubcolumns = col.subcolumns.map(sub => ({
                            ...sub,
                            order: valueOrderMap[sub.value] !== undefined ? valueOrderMap[sub.value] : sub.order,
                            hidden: valueHiddenMap[sub.value] !== undefined ? valueHiddenMap[sub.value] : sub.hidden
                        }));
                        return { ...col, subcolumns: newSubcolumns };
                    });
                } else {
                    updatedColumns = finalColumns;
                }
            } else {
                updatedColumns = (savedUserPreferences && savedUserPreferences[tileName] && savedUserPreferences[tileName]['tableConfig']) ? getMatchedElements(finalColumns, savedUserPreferences[tileName]['tableConfig']['columns']) : finalColumns;
                //  updatedColumns = (ui_state.active_tiles[0] === 'pace') ? mergeUniqueById(updatedColumns, finalColumns) : updatedColumns;
                let columsData = JSON.parse(getFromSession('user_temp_preferences'));
                if (columsData && columsData[tileName] && columsData[tileName]['tableConfig'] && columsData[tileName]['tableConfig']['columns']) {
                    // updatedColumns = getMatchedElements(updatedColumns, columsData[tileName]['tableConfig']['columns']);
                    const matched = getMatchedElements(updatedColumns, columsData[tileName]['tableConfig']['columns']);
                    if (app_state.workspace_controls.sdlyOn) {
                        // Preserve saved column order but re-append any columns absent from saved data (e.g. sdly columns added after save)
                        const matchedIds = new Set(matched.map(col => col.id));
                        const missingColumns = updatedColumns.filter(col => !matchedIds.has(col.id));
                        updatedColumns = [...matched, ...missingColumns];
                    } else {
                        updatedColumns = matched;
                    }
                }
            }
            finalColumns = updatedColumns && updatedColumns.length > 0 ? updatedColumns : finalColumns;

            if (segmented_view && tile_segmented_view) {
                let dateColIndex = columns.findIndex(item => item.type === "dateColumn");
                let dateColumn = columns[dateColIndex];
                if (dateColIndex > -1 && dateColumn["subcolumns_segmented"]) {
                    const newSubCol = dateColumn["subcolumns_segmented"][0];
                    !finalColumns[dateColIndex].subcolumns.some(
                        sub => sub.subcol_id === newSubCol.subcol_id
                    ) && finalColumns[dateColIndex].subcolumns.push(newSubCol);
                }
            }
            finalColumns = finalColumns.map(col =>
                col.id === "staydates"
                    ? {
                        ...col,
                        subcolumns: col.subcolumns.map(sub =>
                            sub.subcol_id === "staydates_segment"
                                ? { ...sub, hidden: (segmentType === "hotel") ? true : false }
                                : sub
                        )
                    }
                    : col
            );
        });
        // debugger;
        //// remove the comparison column after click on the clear comparison button
        if (active_tiles[0] === "pace" && !app_state.workspace_controls.clearComparision) {
            let columnsWithOutComp = finalColumns.slice(0, 2);
            finalColumns = [...columnsWithOutComp];
        }
        // debugger;
        // End //

        /** remove the revpar and sellrate column from the rate plan report  */
        // Only inject the Available subcolumn when the property has the variable capacity
        // permission AND the user has toggled it on — dropped from the array entirely
        // otherwise, rather than kept + hidden, so downstream logic (colSpan, hidden-kpi
        // tracking, saved-preference diffing) never has to special-case a column that isn't
        // really there. Checking the permission here (not just the toggle) means a stale
        // showVariableCapacity=true left over from before the permission was revoked can't
        // resurrect the column.

        if (active_tiles[0] === "otb_v2_multi_segment") {
            let ratePlanColumns = getRatePlanColumn(finalColumns);
            // Toggle Available subcolumn visibility based on variable capacity toggle
            finalColumns.forEach(col => {
                if (['otb_current', 'otb_sdly', 'otb_actual_sdly', 'otb_diff_sdly', 'otb_variance_sdly', 'otb_remaing_pickup_sdly'].includes(col.id)) {
                    col.subcolumns = col.subcolumns.filter(sub =>
                        sub.value !== 'Available' || showVariableCapacity
                    );
                }
            });
        }
        if (['bi_pace_comparison', 'bi_pickup_analysis'].includes(active_tiles[0])) {
            const availableCols = {
                'bi_pace_comparison': ['otb_primary_report', 'otb_sdly', 'otb_diff_sdly', 'otb_end_sdly', 'otb_sdly_pickup_var'],
                'bi_pickup_analysis': ['otb_primary_report', 'otb_pickup_report', 'otb_sdly', 'variance_pickup'],
            };
            const isHotelLevel = ui_state.reports_dpbs.selectedCategory?.includes("Hotel");
            finalColumns.forEach(col => {
                if (availableCols[active_tiles[0]].includes(col.id)) {
                    col.subcolumns = col.subcolumns.filter(sub => {
                        let value = (sub.value !== 'Available' || (showVariableCapacity && isHotelLevel));
                        return value;
                    }
                        // sub.value === 'Available'
                        // ? { ...sub, hidden: !ui_state.showVariableCapacity || !isHotelLevel }
                        //: sub
                    );
                }
            });
        }
        if (active_tiles[0] === 'bi_sensitivity_analysis') {
            finalColumns.forEach(col => {
                if (col.type === 'dataColumn') {
                    col.subcolumns = col.subcolumns.filter(sub =>
                        sub.value !== 'Available' || showVariableCapacity
                    );
                }
            });
        }
        /** end  */

        finalColumns.sort(function (a, b) { return a.order - b.order });
        finalColumns.map((item, index) => {
            let subColumns = item.subcolumns;
            subColumns.sort(function (a, b) { return a.order - b.order });
        })

        let sortedColumns = [...finalColumns];
        // debugger;
        return sortedColumns;
    };

    /** function is used to remove the revpar and sellrate from the rate plan report   */
    const getRatePlanColumn = (finalColumns) => {
        if (app_state.workspace_controls.segmentType === "rate_plan") {
            for (let i = 1; i < finalColumns.length; i++) {
                finalColumns[i]["subcolumns"].map((item, index) => {
                    if (item.display === "RevPAR" || item.display === "SellRate") {
                        finalColumns[i]["subcolumns"][index]["hidden"] = true;
                        finalColumns[i]["subcolumns"] = [...finalColumns[i]["subcolumns"]]
                    }
                })
            }
        }
        let label;
        if (app_state.workspace_controls.segmentType === "rate_plan") {
            label = "Rate Plan";
        } else if (app_state.workspace_controls.segmentType === "room_type") {
            label = "Room Type";
        } else if (app_state.workspace_controls.segmentType === "room_class") {
            label = "Room Class";
        } else {
            label = "Segment";
        }
        finalColumns[0]["subcolumns"].map((itm, idx) => {
            if (itm.display === "segment") {
                finalColumns[0]["subcolumns"][idx]["display"] = label;
                finalColumns[0]["subcolumns"] = [...finalColumns[0]["subcolumns"]]
            }
        })
    }

    const compRef = useRef({
        itemDragged: {},
        itemDroppedOn: {},
        columns: getNeededColumns({ auth, app_state, ui_state })
        // columns: deepCopy(TILES[active_tiles[0]]['tableConfig']['columns']),
        // sortedColumn: TILES[active_tiles[0]]['tableConfig']['columns'][0][0]
    });

    const TableStyle = {
        height: "60vh",
        overflow: "auto",
    };

    let permissionDetails = getPermissions(profile.property_details, app_state.property_id);

    useEffect(() => {
        setIsAtBottom(false);
    }, [data_setup]);

    //Runs only first time just after component rendered
    useEffect(() => {
        let filteredSegments = (segmentType !== 'hotel' && segmented_view) ? ui_state.table_filters.table_reports[segmentType].map(d => d.name) : [];
        filteredSegments = [...new Set(filteredSegments)];

        let selectedCategory = typeof ui_state.reports_dpbs.selectedCategory === 'string' ? [ui_state.reports_dpbs.selectedCategory] : ui_state.reports_dpbs.selectedCategory;
        if (['bi_pace_comparison', 'bi_pickup_analysis'].includes(active_tiles[0]) && typeof selectedCategory === 'object' && selectedCategory.constructor.name === 'Array' && selectedCategory.length) {
            let topSegments = {};
            let system_settings = getAppData(auth, app_state)
            const lvl1_mseg_grouping = deepCopy(system_settings.lvl1_mseg_grouping);

            lvl1_mseg_grouping.forEach(segment => {
                topSegments = { ...topSegments, ...segment };
            });
            let topSegmentsList = [];

            if (selectedCategory && selectedCategory.includes("Hotel")) {
                topSegmentsList = topSegments[selectedCategory];
                // topSegmentsList.unshift("All");
            }
            filteredSegments = [];

            selectedCategory.forEach(cat => {
                if (cat === 'Hotel') {
                    Object.keys(topSegments).forEach(key => {
                        filteredSegments = [...filteredSegments, key];
                    })
                }
                else if (ui_state.reports_dpbs.selectedSegment) {
                    filteredSegments = ui_state.reports_dpbs.selectedSegment
                }
                else {
                    filteredSegments = [...filteredSegments, ...topSegments[cat]];
                }
            });

            filteredSegments = [...new Set(filteredSegments)];
            // debugger;
        }

        if (filteredSegments.includes('all')) {
            let segmentArr = segments.list
            if (segmentType === "room_class") {
                segmentArr = getRoomClass();
            } else if (segmentType === "rate_plan") {
                segmentArr = getRatePlan();
            } else if (segmentType === "room_type") {
                segmentArr = getRoomType();
            }
            segmentArr = segmentArr.map(v => ({ ...v, hidden: false, title: v.name, type: "reports_segments" }))
            let segmentArrUnique = segmentArr.filter((obj, index) => {
                return index === segmentArr.findIndex(o => obj.name === o.name);
            });
            ui_state.table_filters.table_reports[segmentType] = segmentArrUnique;
            filteredSegments = segmentArr.map(d => d.name);
        }
        if (segmentType === "rate_plan" && ui_state.table_filters.table_reports.rate_plan_filter_all_selected) {
            let segmentList = getRatePlan();
            ui_state.table_filters.table_reports.rate_plan = segmentList;
            filteredSegments = segmentList.map(d => d.name);
        }
        setFilteredSegments(filteredSegments);
        if (active_tiles.includes('revpar_index')) {
            if (app_state.workspace_controls.tableType === 'daily') {
                ui_state.table_filters.table_common.kpis = ["hotel_revpar", "market_revpar", "revpar_index", "sdly_hotel_revpar", "sdly_market_revpar", "sdly_revpar_index"];
            } else {
                ui_state.table_filters.table_common.kpis = ["revpar_lift", "hotel_revpar", "hotel_revpar_ly", "market_revpar", "market_revpar_ly", "revpar_index", "revpar_index_ly"];
            }
        } else {
            ui_state.table_filters.table_common.kpis = ['Occ', 'Rooms', 'ADR', 'RevPAR', 'Revenue', 'SellRate', 'Restrictions'];
        }

    }, []);

    useEffect(() => {

        let isSubscribed = true;
        let finalProcessData;
        let date_dba = active_tiles[0] === 'bi_sensitivity_analysis' ? 'dba' : 'date';
        compRef.current.filteredColumns = getFilteredColumns(compRef.current.columns);
        // debugger;

        if (reloadGrid === 'reOrderedMainCols' && compRef.current.data_setup) {
            let t = compRef.current.columns;
            let mainColOrders = compRef.current.columns.map((item) => ({ id: item.id, order: item.order }))
            compRef.current.data_setup.forEach((row, index) => {
                let newOrderColumn = [];
                // compRef.current.data_setup[index].sort()
                mainColOrders.forEach((col) => {
                    let colData = row.find((itm) => itm && col.id === itm.id)
                    newOrderColumn.push(colData);
                })
                compRef.current.data_setup[index].splice(0, row.length, ...newOrderColumn);
            });

            setReloadGrid('applySorting');
        }

        if (reloadGrid === 'applySorting' && compRef.current.data_setup) {
            let finalRows = [];
            let tmpColumns = compRef.current.sortedColumn;
            let sortedColumn = getSortedColumn(compRef.current.columns);
            let data_setup = deepCopy(compRef.current.data_setup);
            data_setup = sortData({ data: data_setup, sortBy: sortedColumn.value, parent: sortedColumn.parent, order: sortedColumn.sorted, workspace_controls: app_state.workspace_controls });
            // if (date_dba === 'date') {
            //     data_setup = compRef.current.data_setup.filter((item) => item[0][date_dba] === '' || filteredDow.includes(moment(item[0].date).format('ddd').toLocaleLowerCase()) || filteredDow.includes('all'));
            // }

            if (date_dba === 'date' && active_tiles[0] !== 'revpar_index') {
                data_setup = data_setup.filter((item) => item[0][date_dba] === '' || filteredDow.includes(moment(item[0].date).format('ddd').toLocaleLowerCase()) || filteredDow.includes('all'));
            }
            if (active_tiles[0] === 'revpar_index' && app_state.workspace_controls.tableType === 'daily') {
                data_setup = data_setup.filter((item) => item[0][date_dba] === '' || filteredDow.includes(moment(item[0].date).format('ddd').toLocaleLowerCase()) || filteredDow.includes('all'));
            }
            if (active_tiles[0] === 'bi_sensitivity_analysis' && segmentType === 'hotel') {
                data_setup = getFilteredData({ data: data_setup, columns: compRef.current.columns });
            } else if (active_tiles[0] === 'otb_v2_multi_segment' && segmentType === 'hotel') {
                data_setup = getFilteredData({ data: data_setup, columns: compRef.current.columns });
            } else if (
                (ui_state.reports_dpbs.selectedCategory.includes("Hotel") &&
                    workspace_controls.segmented_view) ||
                (!ui_state.reports_dpbs.selectedCategory.includes("Hotel")) ||
                (active_tiles[0] === 'otb_v2_multi_segment' &&
                    in_array([segmentType], ['top_market_segment', 'market_segment', 'room_class', 'room_type', 'rate_plan'])
                ) ||
                active_tiles[0] === 'bi_sensitivity_analysis'
            ) {
                let totalsRows = data_setup.filter(item => item[0].segment === 'Total');
                data_setup = data_setup.filter((item) => (item[0][date_dba] === '' && filteredSegments.includes(item[0].segment)) || item[0].segment === 'Total' || filteredSegments.includes(item[0].segment) || filteredSegments.includes('all'));
                totalsRows.forEach(item => {
                    let segmentedRows = data_setup.filter(d => item[0][date_dba] === d[0][date_dba] && d[0].segment !== 'Total');
                    if (workspace_controls.segmented_view) {
                        segmentedRows = getFilteredData({ data: segmentedRows, columns: compRef.current.columns });
                    }
                    if (segmentedRows.length > 0) {

                        let calcTotal = getTotalData(segmentedRows, 'segment');
                        if (active_tiles[0] === 'bi_sensitivity_analysis' && segmentType === 'market_segment') {
                            calcTotal.forEach((col, i) => {
                                let findTotalSaleRateEle = item.find(d => d.id === col.id);
                                col.SellRate = findTotalSaleRateEle.SellRate;
                            })
                        }
                        let totalOfFiltered = deepCopy([...[item[0]], ...calcTotal]);
                        totalOfFiltered.forEach((col, i) => {
                            if (item[i]) {
                                totalOfFiltered[i].id = item[i].id;
                                if (i > 0 && item[i]._vcap !== undefined) {
                                    // _vcap itself must survive onto totalOfFiltered whenever present —
                                    // not only when it differs from base Capacity — because downstream
                                    // grand-total aggregation (getTotalData's effectiveVcap) reads _vcap
                                    // off this row directly. Gating the copy on _vcapDiffers meant _vcap
                                    // silently vanished here whenever VCapacity happened to equal
                                    // Capacity for a date, breaking Available at the grand-total row.
                                    totalOfFiltered[i]._vcap = item[i]._vcap;
                                    totalOfFiltered[i]._vcapLabel = item[i]._vcapLabel;
                                    totalOfFiltered[i]._vcapDiffers = item[i]._vcapDiffers;
                                    // variance_pickup's Rooms/Revenue here are already a current-minus-prior
                                    // DIFFERENCE (not one snapshot), and its _vcap is a single snapshot's
                                    // capacity — Rooms/_vcap is meaningless for a diff column (it produced
                                    // Occ% in the hundreds whenever the capacity gap actually differed, which
                                    // is exactly when this branch fires). The segment-sum above already yields
                                    // the correct value: sum of each segment's own (current/cap - prior/cap).
                                    const isDiffColumn = item[i].id === 'variance_pickup';
                                    if (!isDiffColumn && showVariableCapacity && item[i]._vcapDiffers) {
                                        totalOfFiltered[i].Occ = convertToPercent(totalOfFiltered[i].Rooms / totalOfFiltered[i]._vcap);
                                        totalOfFiltered[i].RevPAR = totalOfFiltered[i].Revenue / totalOfFiltered[i]._vcap;
                                    }
                                }
                                if (i > 0 && showVariableCapacity && 'Available' in item[i] && item[i]._vcap !== undefined && typeof totalOfFiltered[i].Rooms === 'number') {
                                    totalOfFiltered[i].Available = round(item[i]._vcap - totalOfFiltered[i].Rooms);
                                }
                            }
                        });
                        // Percentage-typed comparison columns (e.g. "% Variance to SDLY") can't be
                        // recomputed via the vcap-numeric path above because their Rooms field is
                        // itself a percentage string. Derive Available% instead from the TY/SDLY
                        // sibling columns' own Available, already fixed by the pass above.
                        totalOfFiltered.forEach((col, i) => {
                            if (item[i] && i > 0 && showVariableCapacity && 'Available' in item[i] &&
                                typeof totalOfFiltered[i].Rooms === 'string' && totalOfFiltered[i].Available === undefined) {
                                const tyCol = totalOfFiltered.find(c => c && (c.id === 'otb_current' || c.id === 'otb_primary_report'));
                                const sdlyCol = totalOfFiltered.find(c => c && c.id === 'otb_sdly');
                                if (tyCol && sdlyCol && typeof tyCol.Available === 'number' && typeof sdlyCol.Available === 'number' && sdlyCol.Available) {
                                    const variancePct = (tyCol.Available - sdlyCol.Available) / sdlyCol.Available;
                                    totalOfFiltered[i].Available = (variancePct && isFinite(variancePct)) ? convertToPercent(variancePct) + "%" : "0%";
                                } else {
                                    totalOfFiltered[i].Available = "0%";
                                }
                            }
                        });

                        if (totalOfFiltered.length) {
                            if (workspace_controls.segmented_view) {
                                finalRows = [...finalRows, ...segmentedRows, ...[totalOfFiltered]];
                            } else {
                                finalRows = [...finalRows, ...[totalOfFiltered]];
                                finalRows = getFilteredData({ data: finalRows, columns: compRef.current.columns });

                            }
                        }

                    }
                });
                let finalSegmentsTotal = [];

                if (finalRows.length && workspace_controls.segmented_view) {
                    finalRows = finalRows.filter(row => row && row[0] && row[0][date_dba] !== '');
                    let uniqueFilteredSegments = getUnique([...filteredSegments]);
                    uniqueFilteredSegments.forEach((item) => {
                        let segmentTotalRow = finalRows.filter((row) => row && row[0] && row[0].segment === item);
                        let dateCol = deepCopy(finalRows[0][0]);
                        if (date_dba === 'date') {
                            dateCol.date = '';
                            dateCol.dow = '';
                        }
                        if (date_dba === 'dba') {
                            dateCol.dba = '';
                        }
                        dateCol.segment = segments.map[item] ? segments.map[item] : item; dateCol.segment = item;

                        let calcTotal = getTotalData(segmentTotalRow, 'segmentTotal');

                        if (calcTotal.length) {
                            segmentTotalRow = [...[dateCol], ...getTotalData(segmentTotalRow, 'segmentTotal')];
                            finalSegmentsTotal = [...finalSegmentsTotal, ...[segmentTotalRow]];
                        }
                    });
                    finalRows = [...finalRows, ...finalSegmentsTotal];

                }
                data_setup = deepCopy(finalRows);
                data_setup = sortData({ data: data_setup, sortBy: sortedColumn.value, parent: sortedColumn.parent, order: sortedColumn.sorted, workspace_controls: app_state.workspace_controls });

            } else {
                // debugger;
                data_setup = sortData({ data: data_setup, sortBy: sortedColumn.value, parent: sortedColumn.parent, order: sortedColumn.sorted, workspace_controls: app_state.workspace_controls });
                data_setup = getFilteredData({ data: data_setup, columns: compRef.current.columns });
            }
            // compRef.current.data_setup = deepCopy(data_setup);
            setDataSetup(data_setup);
            setReloadGrid('appliedSorting');
            setCompLoadStatus('sortedCols');
        }

        if (!['applySorting', 'appliedSorting'].includes(reloadGrid) && !compRef.current.data_setup) {
            if (compLoad && displayData && displayData.length > 0) {
                setupData();
            }
        }

        if (hasInfoBoxReportTable()) {
            ui_state.showDownloadReport = false;
        } else {
            ui_state.showDownloadReport = true;
        }
        if (app_state.data_load) {
            dispatch(
                updateAppState("data_load", {
                    app_state: {
                        data_load: false,
                    },
                    ui_state: {
                        ...ui_state,
                        // showspinner: true
                    }
                })
            );
        }


        return () => (isSubscribed = false);

    }, [displayData, compLoad, reloadGrid]);

    const { dayDate } = app_state.workspace_controls;


    useEffect(() => {
        let isSubscribed = true;
        let propDetails = getPermissions(profile.property_details, app_state.property_id);
        app_state.workspace_controls.rate_plan = (propDetails.permissions.rate_plan) ? propDetails.permissions.rate_plan : 1;
        app_state.workspace_controls.room_type = (propDetails.permissions.room_type) ? propDetails.permissions.room_type : 1;

        dispatch({
            type: UPDATE_STATE,
            payload: {
                app_state: {
                    workspace_controls: { ...app_state.workspace_controls }
                }
            }
        })
        // dispatch(updateAppState("toggleChartTableView", {
        //     app_state: {
        //         workspace_controls: { ...app_state.workspace_controls }
        //     }
        // }));

        if (isSubscribed) {
            if (!ui_state.showspinner) {
                //setCompLoad(false);
                //Handle multiple data set for intellimerge
                // debugger
                if (compDisplayData && compDisplayData.constructor.name === 'Array' && compDisplayData.length) {
                    // check for segmentrd data 
                    let transformedData = [];
                    if (workspace_controls.scopeType === 'Dba' && compDisplayData[0].data && !compDisplayData[0].data.length) {
                        transformedData = transformSegmentData(app_state, auth, compDisplayData[1].data, { segmentedOn: app_state.workspace_controls.segmented_view, tile: ui_state.active_tiles[0], segments: segments });
                    } else {
                        if (ui_state.active_tiles[0] === "rm_room_type_ratesend_status" || ui_state.active_tiles[0] === "DailyRatesendStatus") {
                            let data = (app_state.workspace_controls.logsRatePushMode === "date_range") ? compDisplayData[0].data : compDisplayData[1].data;
                            transformedData = transformSegmentData(app_state, auth, data, { segmentedOn: app_state.workspace_controls.segmented_view, tile: ui_state.active_tiles[0], segments: segments });
                        } else {
                            transformedData = transformSegmentData(app_state, auth, compDisplayData[0].data, { segmentedOn: app_state.workspace_controls.segmented_view, tile: ui_state.active_tiles[0], segments: segments });
                        }

                    }
                    if (ui_state.active_tiles[0] === "revpar_index") {
                        setDisplayData([transformedData]);
                    } else {
                        setDisplayData(transformedData);
                    }
                    setCompLoad(true);
                    // setupData();
                }
                if (compDisplayData && compDisplayData.data) {
                    let transformedData = transformSegmentData(app_state, auth, compDisplayData.data, { segmentedOn: app_state.workspace_controls.segmented_view, tile: ui_state.active_tiles[0], segments: segments });
                    // debugger;
                    setDisplayData(transformedData);
                    setCompLoad(true);
                    // setupData();
                }

                if (app_state.workspace_controls.downloadExportButton === true) {
                    let exportFileName = moment(app_state.as_of_date).format('MMM DD YYYY') + "_" + selectedPropertyName + "_" + ui_state.active_tiles[0];
                    // if (ui_state.active_tiles[0] !== "restrictions_push_status" &&
                    //     ui_state.active_tiles[0] !== "otb_v2_multi_segment" &&
                    //     ui_state.active_tiles[0] !== "rm_room_type_ratesend_status") {
                    //     let table = document.getElementById("mainTable");
                    //     downloadReportToExcel(exportFileName, ui_state.active_tiles[0], table);
                    // } else {
                    const table = document.createElement('table');
                    const header = document.querySelector("#mainTable .table-head").cloneNode(true);

                    // Add same style for row 1 for Notes and Events
                    const firstRow = header.querySelectorAll('tr')[0];
                    if (firstRow && !['bi_sensitivity_analysis', 'revpar_index'].includes(active_tiles[0])) {
                        // Add the Events column heading to the first row of the header
                        const eventsTh = firstRow.querySelector('th').cloneNode(true);
                        eventsTh.textContent = 'Events';
                        eventsTh.setAttribute('colspan', '2');
                        if (!sdlyOn) {
                            eventsTh.removeAttribute('colspan');
                        }
                        firstRow.appendChild(eventsTh);
                    }

                    const secondRow = header.querySelectorAll('tr')[1];
                    if (secondRow && !['bi_sensitivity_analysis', 'revpar_index'].includes(active_tiles[0])) {
                        // Add the new "Event TY" column heading to the second row of the header
                        const eventsTh2 = secondRow.querySelector('th').cloneNode(true);
                        eventsTh2.textContent = 'Event TY';
                        secondRow.appendChild(eventsTh2);

                        // Add the new "Event SDLY" column heading to the second row of the header
                        if (sdlyOn) {
                            const secondRow2 = header.querySelectorAll('tr')[1];
                            if (secondRow2) {
                                const eventsTh2 = secondRow2.querySelector('th').cloneNode(true); // Clone an existing th to retain styles
                                eventsTh2.textContent = dayDate === 'day' ? 'Event SDLY' : 'Event SDTLY';
                                secondRow2.appendChild(eventsTh2);
                            }
                        }
                    }

                    table.append(header);
                    let data = [];
                    let columnNodes = document.querySelectorAll(".filter-position-r .col-head-label");
                    let colNames = [];
                    columnNodes.forEach(item => {
                        colNames.push(item.textContent);
                    })
                    let colNameHash = {};

                    let data_cols = [];
                    compRef.current.columns.forEach(col => {
                        col.subcolumns.forEach(subcol => {
                            // Regular data rows are gated on this DOM-scraped colNameHash, while the
                            // Total row (and the reorder step that runs after, for every row) are
                            // gated on subcol.hidden directly. Those two sources of truth can disagree
                            // — e.g. right after toggling Variable Capacity, the header DOM may not
                            // have re-rendered yet when Export is clicked, so a newly-visible column
                            // like Available won't be in colNames even though config already shows it.
                            // When that happens, regular rows silently drop the key while the Total
                            // row keeps it, so generateTable's positional cell insertion (Object.keys
                            // order, no header-matching) shifts every subsequent cell in that row —
                            // the reported "distorted" export. Falling back to !subcol.hidden keeps
                            // the row's key set consistent regardless of DOM render timing.
                            if (colNames.includes(subcol.display) || !subcol.hidden) {
                                colNameHash[subcol.value] = subcol.display;
                                //data_cols.push(subcol.value);
                            }
                        })
                    })
                    let totalArrObj = [];
                    if (!['bi_sensitivity_analysis', 'revpar_index', "DailyRatesendStatus", "restrictions_push_status", "rm_room_type_ratesend_status"].includes(ui_state.active_tiles[0])) {
                        totalArrObj.push({
                            TotalRow: "TotalRow",
                            id: 'TotalRow'
                        })
                    }

                    let data_setupExcel = deepCopy(data_setup);
                    const totalData = getTotalData(data_setup);
                    data_setupExcel.push(totalArrObj);
                    data_setupExcel.forEach((dItem, idx) => {
                        let dataPoint = {};
                        dItem.forEach((item, index) => {
                            if (item.RoomsRestrictions) {
                                let resArray = [];
                                item.RoomsRestrictions.forEach(res => {
                                    let restrictions = [];
                                    if (res.room_type) {
                                        restrictions.push(res.room_type);
                                    } else {
                                        restrictions.push("House");
                                    }
                                    restrictions = restrictions.concat(getRestrictionsArray(res));
                                    resArray.push(restrictions.join(" "))
                                })
                                item.RoomsRestrictions = resArray.join(", ");
                            }
                            if (item.Roomsrate) {
                                let romRatesArr = [];
                                item.Roomsrate.forEach(room => {
                                    romRatesArr.push(room.room_code + " " + room.changed_rate);
                                })
                                item.Roomsrate = romRatesArr.join(", ");
                            }
                            if (ui_state.active_tiles[0] === "otb_v2_multi_segment" || item.id === "otb_current" || ui_state.active_tiles[0] === "bi_sensitivity_analysis") {
                                if (!ui_state.active_tiles[0] === "bi_sensitivity_analysis") {
                                    delete item.SellRate;
                                }
                                // preferredOrder rebuilds the object keeping only the listed keys —
                                // Available must be listed here or every regular row silently drops
                                // it while the separately-built grand-total row keeps it, causing a
                                // key-count mismatch (generateTable inserts cells positionally with
                                // no header-matching, so a missing key shifts the rest of that row).
                                item = (item.hasOwnProperty('Rooms')) ? preferredOrder(item, ['Occ', 'Rooms', 'ADR', 'RevPAR', 'Revenue', 'SellRate', 'Available']) : item;
                            }
                            if (['bi_pace_comparison', 'bi_pickup_analysis'].includes(active_tiles[0])) {
                                if (!segmented_view) {
                                    delete item.segment;
                                }
                                if (item.id === "sdly_actual" || item.id === "sdtly_actual") {
                                    delete item.SellRate;
                                }
                                item = (item.hasOwnProperty('Rooms')) ? preferredOrder(item, ['Occ', 'Rooms', 'ADR', 'RevPAR', 'Revenue', 'SellRate', 'Available']) : item;
                                if (segmented_view) {
                                    item = (item.hasOwnProperty('segment')) ? preferredOrder(item, ['date', 'dow', 'segment']) : item;
                                }
                            }
                            Object.keys(item).forEach(key => {
                                if ((colNameHash[key] || key === "segment") && key !== "id") {
                                    let value = (item[key]) ? item[key] : 0;
                                    if (!item[key] && (key === "date" || key === "dow")) {
                                        value = "";
                                    }
                                    if (value === Infinity || value === -Infinity) {
                                        value = 0;
                                    }
                                    if (typeof value === "string" && value.indexOf("Infinity") !== -1) {
                                        value = value.replace("Infinity", "0")
                                    }
                                    dataPoint[key + "-" + index] = value;
                                }
                            })
                        })

                        if (!['bi_sensitivity_analysis', 'revpar_index', "DailyRatesendStatus", "restrictions_push_status", "rm_room_type_ratesend_status"].includes(active_tiles[0])) {
                            if (segmented_view) {
                                // Add the new columns here if the row is Total
                                if (dItem[0].segment === "Total") {
                                    dataPoint["Event TY"] = calculateEventTY(dItem);
                                    if (sdlyOn) {
                                        if (dayDate === 'day') {
                                            dataPoint["Event SDLY"] = calculateEventSDLY(dItem);
                                        } else {
                                            dataPoint["Event SDTLY"] = calculateEventSDLY(dItem);
                                        }
                                    }
                                }
                            }
                            else {
                                // Add the new columns here if the row is not Total
                                if (!dItem[0].TotalRow) {
                                    dataPoint["Event TY"] = calculateEventTY(dItem);
                                    if (sdlyOn) {
                                        if (dayDate === 'day') {
                                            dataPoint["Event SDLY"] = calculateEventSDLY(dItem);
                                        } else {
                                            dataPoint["Event SDTLY"] = calculateEventSDLY(dItem);
                                        }
                                    }
                                }
                            }
                        }

                        if (dItem.length > 0 && dItem[0].TotalRow && dItem[0].TotalRow === "TotalRow") {
                            dItem = data_setupExcel[0];

                            // Build a map from column id → its position in dItem
                            const totalDItemIdToIndex = {};
                            dItem.forEach((item, index) => {
                                if (item.id) totalDItemIdToIndex[item.id] = index;
                            });

                            let count = 0;
                            // Iterate in visual column order; count increments per non-date column,
                            // matching how totalData is indexed (one entry per non-date column group).
                            compRef.current.columns.forEach(col => {
                                const index = totalDItemIdToIndex[col.id];
                                if (index === undefined) return;

                                const visibleSubcols = col.subcolumns.filter(subcol => !subcol.hidden);
                                visibleSubcols.forEach(subcol => {
                                    const key = subcol.value;
                                    if (key === 'id' || key === 'segment_code') return;

                                    let value;
                                    if (key === 'date' || key === 'date_market_summary' || key === 'month') {
                                        value = 'Total';
                                    } else if (key === 'dow') {
                                        value = '';
                                    } else if (key.toLowerCase() === 'segment') {
                                        value = '';
                                    } else if (key === 'Available' && ['bi_pace_comparison', 'bi_pickup_analysis'].includes(active_tiles[0]) && showVariableCapacity) {
                                        // Mirror the on-screen footer's correction (see the identical block
                                        // guarding col.value === 'Available' above in the render path): sum each
                                        // date row's own already-correct Available delta rather than trusting
                                        // getTotalData's effectiveVcap-based total, which sums raw capacities
                                        // across rows and produces a nonsensical grand total for pickup deltas.
                                        let availableTotal = 0;
                                        data_setup.forEach(items => {
                                            const isContributing = app_state.workspace_controls.segmented_view
                                                ? items[0]?.segment === 'Total' && items[0]?.date !== ''
                                                : items[0]?.date !== '';
                                            const colItem = items[index];
                                            if (isContributing && colItem && typeof colItem.Available === 'number') {
                                                availableTotal += colItem.Available;
                                            }
                                        });
                                        value = availableTotal;
                                    } else {
                                        value = (totalData[count]) ? totalData[count][key] : "";
                                        if (isNaN(value) || value === Infinity || value === -Infinity) {
                                            if (['Occ', 'Rooms', 'ADR', 'RevPAR', 'Revenue', 'SellRate', 'Available'].includes(key)) {
                                                if (value === "" || value === 'NaN' || Number.isNaN(value) || value === 'Infinity' || value === '-Infinity' || value === Infinity || value === -Infinity) {
                                                    value = 0;
                                                }
                                                if (value === 'Infinity%' || value === '-Infinity%') {
                                                    value = '0%';
                                                }
                                            } else {
                                                if (value === "" || value === 'NaN' || Number.isNaN(value) || value === 'Infinity' || value === '-Infinity' || value === Infinity || value === -Infinity) {
                                                    value = "";
                                                }
                                                if (value === 'Infinity%' || value === '-Infinity%') {
                                                    value = '0%';
                                                }
                                            }
                                        }
                                    }
                                    dataPoint[key + '-' + index] = value;
                                });

                                // count increments per non-date column, matching original logic (index !== 0)
                                if (col.type !== 'dateColumn') {
                                    count++;
                                }
                            });
                        }

                        // Reorder dataPoint keys to match the visual column order (respects drag-drop column reordering).
                        // The header is cloned from the DOM (already in visual order), but dataPoint keys are
                        // inserted in original data order — this realigns them so data cells match header cells.
                        const dItemIdToIndex = {};
                        dItem.forEach((item, index) => {
                            if (item.id) dItemIdToIndex[item.id] = index;
                        });
                        const reorderedDataPoint = {};
                        const hiddenKeySet = new Set();
                        compRef.current.columns.forEach(col => {
                            const index = dItemIdToIndex[col.id];
                            if (index === undefined) return;
                            col.subcolumns.forEach(subcol => {
                                const key = subcol.value + "-" + index;
                                if (subcol.hidden) {
                                    hiddenKeySet.add(key);
                                } else if (dataPoint.hasOwnProperty(key)) {
                                    reorderedDataPoint[key] = dataPoint[key];
                                }
                            });
                        });
                        // Append any remaining keys not covered by columns (e.g. Events appended at end).
                        // Skip keys that belong to hidden subcolumns (they may be in dataPoint due to
                        // colNameHash display-name collisions when the same KPI name is visible elsewhere).
                        Object.keys(dataPoint).forEach(key => {
                            if (!reorderedDataPoint.hasOwnProperty(key) && !hiddenKeySet.has(key)) {
                                reorderedDataPoint[key] = dataPoint[key];
                            }
                        });

                        data.push(reorderedDataPoint);
                    })
                    const tBody = generateTable(table, data)
                    if (app_state.workspace_controls.exportType == 'csv') {
                        downloadcsvwithTable(table, exportFileName, compRef.current.columns);
                    } else {
                        downloadReportToExcel(exportFileName, ui_state.active_tiles[0], table);

                    }
                    //}
                    dispatch(updateAppState("toggleChartTableView", {
                        app_state: {
                            workspace_controls: { ...app_state.workspace_controls, downloadExportButton: false, }
                        }
                    }, "dashboard"));
                }
            }
        }
        return () => (isSubscribed = false);
    }, [ui_state.showspinner,
    workspace_controls.sdlyOn,
    workspace_controls.scopeType,
    workspace_controls.downloadExportButton,
    ]);

    const onDragStartHandler = (columParam) => {
        return (event) => {
            // event.preventDefault();
            event.dataTransfer.setData("columnMeta", JSON.stringify(columParam));
            compRef.current.itemDragged = deepCopy(columParam);
            // debugger;
        }
    };

    const calculateEventTY = (dItem) => {
        const formatted_stay_date = dateFormat(dItem[0].date, "YYYY-MM-DD");
        let current_stay_date = dateFormat(formatted_stay_date, "YYYY/MM/DD")

        const filteredEventList = eventList.filter(event =>
            isDateInRange(formatted_stay_date, event.start_date, event.end_date) && event.is_ignored === false
        );

        let EventData = filteredEventList.map(event => event.title).join(", ");

        return EventData
    }
    const calculateEventSDLY = (dItem) => {
        const formatted_stay_date = dateFormat(dItem[0].date, "YYYY-MM-DD");
        const formatted_comp_date = formattedCompDateCalc(sdlyOn, formatted_stay_date, app_state);
        let current_stay_date = dateFormat(formatted_comp_date, "YYYY/MM/DD")

        const filteredEventList = eventListSDLY.filter(event =>
            isDateInRange(formatted_comp_date, event.start_date, event.end_date) && event.is_ignored === false
        );

        let EventData = filteredEventList.map(event => event.title).join(", ");

        return EventData
    }


    const mainColumnOnDropHandler = (columParam) => {
        return (event) => {
            event.preventDefault();
            let columnMeta = JSON.parse(event.dataTransfer.getData("columnMeta"));
            const draggedCellOrder = columnMeta.order;
            const draggedCellOrderIndex = compRef.current.columns.findIndex(col => col.order === draggedCellOrder);
            const droppedCellOrder = columParam.order;
            const droppedCellOrderIndex = compRef.current.columns.findIndex(col => col.order === droppedCellOrder);
            compRef.current.itemDroppedOn = columParam;
            if (droppedCellOrderIndex === 0) return;

            compRef.current.columns.map((mainCol, i) => {
                if (mainCol.type === "dateColumn") return;
                //moving to left
                if (draggedCellOrder > droppedCellOrder && i <= draggedCellOrderIndex) {
                    // debugger;
                    if (draggedCellOrderIndex === i) {
                        mainCol.order = droppedCellOrder;
                    } else if (i <= droppedCellOrderIndex) {
                        mainCol.order = mainCol.order + 1;
                    }
                }
                //moving to right
                if (draggedCellOrder < droppedCellOrder && i >= draggedCellOrderIndex) {
                    // debugger;
                    if (draggedCellOrderIndex === i) {
                        mainCol.order = droppedCellOrder;
                    } else if (i >= droppedCellOrderIndex) {
                        mainCol.order = mainCol.order - 1;
                    }
                }
            });
            compRef.current.columns = processColumnsNew(compRef.current.columns);
            // setupData();
            let ts = Date.now();
            // setReloadGrid(ts);
            setCompLoadStatus('loading');
            setReloadGrid('reOrderedMainCols');

            // lrv-3129 saving updated columns in session storage.
            let tempData = '';
            const activeTile = ui_state.active_tiles[0];
            const tile = getTileKey(activeTile, app_state.workspace_controls, app_state.property_id);
            // Snapshot reference before savedUserPreferences is mutated by the splice below
            const referenceColumns = savedUserPreferences?.[tile]?.tableConfig?.columns
                ? deepCopy(savedUserPreferences[tile].tableConfig.columns)
                : TILES[activeTile]['tableConfig']?.columns;

            if (savedUserPreferences && Object.keys(savedUserPreferences).length > 0) {
                tempData = { ...savedUserPreferences };
                tempData[tile] = { ...(tempData[tile] || {}) };
                tempData[tile].tableConfig = { ...(tempData[tile].tableConfig || {}) };
                // tempData[tile].tableConfig.columns = compRef.current.columns;

                if (savedUserPreferences[tile]?.tableConfig?.columns) {
                    compRef.current.columns.forEach((col) => {
                        let existColId = savedUserPreferences[tile].tableConfig.columns.findIndex((item) => item.id === col.id);
                        savedUserPreferences[tile].tableConfig.columns.splice(existColId, 1, deepCopy(col));
                    })
                    tempData[tile].tableConfig.columns = savedUserPreferences[tile].tableConfig.columns;

                } else {
                    tempData[tile].tableConfig.columns = compRef.current.columns;
                }

                updateSessionObject('user_temp_preferences', tempData);
                // addToSession('user_temp_preferences', JSON.stringify(tempData));
            } else {
                tempData = {};
                // const tile = (['pace', 'market'].includes(ui_state.active_tiles[0])) ? ui_state.active_tiles[0] + "_" + app_state.workspace_controls.scopeType : active_tiles[0];
                tempData[tile] = {};
                tempData[tile]['tableConfig'] = {};
                tempData[tile]['tableConfig']['columns'] = compRef.current.columns;
                // addToSession('user_temp_preferences', JSON.stringify(tempData));
                updateSessionObject('user_temp_preferences', tempData);

            }
            const isChanged = in_array(ui_state.active_tiles, ['bi_sensitivity_analysis'])
                ? false
                : referenceColumns
                    ? compRef.current.columns.some(col => {
                        const refCol = referenceColumns.find(r => r.id === col.id);
                        return !refCol || refCol.order !== col.order;
                    })
                    : true;
            dispatch(updateAppState('columnSettingsChanged', { ui_state: { columnSettingsChanged: isChanged } }));


        }
    };
    const dataColumnOnDropHandler = (columParam) => {
        return (event) => {
            event.preventDefault();
            let columnMeta = JSON.parse(event.dataTransfer.getData("columnMeta"));
            compRef.current.itemDroppedOn = columParam;
            // debugger;
            let { itemDragged, itemDroppedOn } = compRef.current;
            if (columnMeta.parent === columParam.parent) {
                let draggedOrder = columnMeta.order;
                let droppedOrder = columParam.order;
                let mainColumn = compRef.current.columns.filter((item) => item.id === columnMeta.parent);
                const isBiSensitivity = in_array(ui_state.active_tiles, ['bi_sensitivity_analysis']);
                compRef.current.columns.map((mainCol, i) => {
                    if (mainCol.id === columnMeta.parent) {
                        // Normal swap for the dragged column's parent
                        compRef.current.columns[i].subcolumns.map((col) => {
                            if (col.value === columnMeta.value) {
                                col.order = droppedOrder;
                            }
                            if (col.value === columParam.value) {
                                col.order = draggedOrder;
                            }
                        });
                    } else if (isBiSensitivity && mainCol.type !== 'dateColumn') {
                        // Apply the same order swap to all other data columns by matching order number.
                        // dateColumn (staydates) is excluded — it has independent subcolumn ordering.
                        compRef.current.columns[i].subcolumns.map((col) => {
                            if (col.order === draggedOrder) {
                                col.order = droppedOrder;
                            } else if (col.order === droppedOrder) {
                                col.order = draggedOrder;
                            }
                        });
                    }
                });
                let columns = processColumnsNew(compRef.current.columns);
                compRef.current.columns = columns;
                // setupData();
                let ts = Date.now();
                setCompLoadStatus('loading');
                // setReloadGrid(ts);
                setReloadGrid('applySorting');

                // lrv-3129 saving updated columns in session storage.
                let tempData = '';
                const activeTile = ui_state.active_tiles[0];
                const tile = getTileKey(activeTile, app_state.workspace_controls, app_state.property_id);
                // Snapshot reference before savedUserPreferences is mutated by the splice below
                const referenceColumns = savedUserPreferences?.[tile]?.tableConfig?.columns
                    ? deepCopy(savedUserPreferences[tile].tableConfig.columns)
                    : TILES[activeTile]['tableConfig']?.columns;
                if (savedUserPreferences && Object.keys(savedUserPreferences).length > 0) {
                    tempData = { ...savedUserPreferences };
                    tempData[tile] = { ...(tempData[tile] || {}) };
                    tempData[tile].tableConfig = { ...(tempData[tile].tableConfig || {}) };
                    if (savedUserPreferences[tile]?.tableConfig?.columns) {
                        compRef.current.columns.forEach((col) => {
                            let existColId = savedUserPreferences[tile].tableConfig.columns.findIndex((item) => item.id === col.id);
                            savedUserPreferences[tile].tableConfig.columns.splice(existColId, 1, deepCopy(col));
                        })
                        tempData[tile].tableConfig.columns = savedUserPreferences[tile].tableConfig.columns;

                    } else {
                        tempData[tile].tableConfig.columns = compRef.current.columns;
                    }
                    updateSessionObject('user_temp_preferences', tempData);

                } else {
                    tempData = {};
                    tempData[tile] = {};
                    tempData[tile]['tableConfig'] = {};
                    tempData[tile]['tableConfig']['columns'] = compRef.current.columns;
                    updateSessionObject('user_temp_preferences', tempData);
                }
                const isChanged = in_array(ui_state.active_tiles, ['bi_sensitivity_analysis'])
                    ? false
                    : referenceColumns
                        ? compRef.current.columns.some(col => {
                            const refCol = referenceColumns.find(r => r.id === col.id);
                            if (!refCol || refCol.order !== col.order) return true;
                            return col.subcolumns?.some(sub => {
                                const refSub = refCol.subcolumns?.find(s => s.value === sub.value);
                                return !refSub || refSub.order !== sub.order;
                            }) || false;
                        })
                        : true;
                dispatch(updateAppState('columnSettingsChanged', { ui_state: { columnSettingsChanged: isChanged } }));

            }
        }
    };

    const columnToggleHandler = (item, currSubcols, hiddenStatus) => {
        const isBiSensitivity = in_array(ui_state.active_tiles, ['bi_sensitivity_analysis']);
        let columns = compRef.current.columns;
        let parentCol = currSubcols && currSubcols.length ? currSubcols[0].parent : null;
        let items = item;
        if (item && item.constructor.name === 'Object') {
            items = [item]
        }

        // Snapshot reference BEFORE mutating subcolumns — getMatchedElements uses a shallow
        // spread so compRef.current.columns shares subcolumn object references with
        // savedUserPreferences; mutating hidden flags below would also mutate the reference.
        const activeTile = ui_state.active_tiles[0];
        const tile = getTileKey(activeTile, app_state.workspace_controls, app_state.property_id);
        const referenceColumns = savedUserPreferences?.[tile]?.tableConfig?.columns
            ? deepCopy(savedUserPreferences[tile].tableConfig.columns)
            : TILES[activeTile]['tableConfig']?.columns;

        let hiddenSubcols = currSubcols.filter(col => col.hidden);
        hiddenSubcols = hiddenSubcols.map(col => col.value);
        columns.forEach(column => {
            let subcols = column.subcolumns;
            if (isBiSensitivity) {
                subcols.forEach(subcol => {
                    if (hiddenSubcols.includes(subcol.value)) {
                        subcol.hidden = true;
                    } else {
                        subcol.hidden = false;
                    }
                })
            } else {
                if (parentCol && subcols && subcols.length && subcols[0].parent === parentCol) {
                    subcols.forEach(subcol => {
                        if (hiddenSubcols.includes(subcol.value)) {
                            subcol.hidden = true;
                        } else {
                            subcol.hidden = false;
                        }
                    })
                }
            }
        });

        compLoadStatus = 'sortingCols';
        reloadGrid = 'applySorting';
        setCompLoadStatus('sortingCols');
        setReloadGrid('applySorting');

        let tempData = '';
        if (savedUserPreferences && Object.keys(savedUserPreferences).length > 0) {
            tempData = { ...savedUserPreferences };
            // const tile = (['pace', 'market'].includes(ui_state.active_tiles[0])) ? ui_state.active_tiles[0] + "_" + app_state.workspace_controls.scopeType : active_tiles[0];
            tempData[tile] = { ...(tempData[tile] || {}) };
            tempData[tile].tableConfig = { ...(tempData[tile].tableConfig || {}) };
            tempData[tile].tableConfig.columns = columns;
            // addToSession('user_temp_preferences', JSON.stringify(tempData));
            updateSessionObject('user_temp_preferences', tempData);

        } else {
            tempData = {};
            // const tile = (['pace', 'market'].includes(ui_state.active_tiles[0])) ? ui_state.active_tiles[0] + "_" + app_state.workspace_controls.scopeType : active_tiles[0];
            tempData[tile] = {};
            tempData[tile]['tableConfig'] = {};
            tempData[tile]['tableConfig']['columns'] = compRef.current.columns;
            // addToSession('user_temp_preferences', JSON.stringify(tempData));
            updateSessionObject('user_temp_preferences', tempData);
        }
        const isChanged = in_array(ui_state.active_tiles, ['bi_sensitivity_analysis'])
            ? false
            : referenceColumns
                ? columns.some(col => {
                    const refCol = referenceColumns.find(r => r.id === col.id);
                    if (!refCol || refCol.order !== col.order) return true;
                    return col.subcolumns?.some(sub => {
                        const refSub = refCol.subcolumns?.find(s => s.value === sub.value);
                        return !refSub || refSub.order !== sub.order || !!refSub.hidden !== !!sub.hidden;
                    }) || false;
                })
                : true;
        dispatch(updateAppState('columnSettingsChanged', { ui_state: { columnSettingsChanged: isChanged } }));
    }
    const applyFilterHandler = (selectedSegment, type) => {
        let ts = Date.now();
        if (selectedSegment && selectedSegment[0] && type !== 'column') {
            filteredSegments = selectedSegment;
            setFilteredSegments(selectedSegment);
        }
        compLoadStatus = 'sortingCols';
        reloadGrid = 'applySorting';
        setCompLoadStatus('sortingCols');
        setReloadGrid('applySorting');
    };
    const clearFilterHandler = (item, type) => {
        // debugger;
        if (type === 'all') {
            compRef.current.columns.map((main, i) => {
                main.subcolumns.map((sub, j) => {
                    //it depends on property sorted
                    sub.filter = null;
                });
            });
        }
        compLoadStatus = 'sortingCols';
        reloadGrid = 'applySorting';
        setCompLoadStatus('sortingCols');
        setReloadGrid('applySorting');
    };

    const onOrderByChangeHandler = (item) => {
        // debugger;
        setCompLoadStatus('sortingCols');
        // let cols = compRef.current.columns;
        compRef.current.sortedColumn = deepCopy(item);
        compRef.current.columns.map((main) => {
            if (main.id === item.parent) {
                main.subcolumns.map((col) => {
                    if (col.value === item.value) {
                        col.sorted = item.sorted;
                    } else {
                        col.sorted = null;
                    }
                })
            } else {
                main.subcolumns.map((col) => {
                    col.sorted = null;
                });
            }

        });
        let ts = Date.now();
        compLoadStatus = 'sortingCols';
        reloadGrid = 'applySorting';
        setCompLoadStatus('sortingCols');
        setReloadGrid('applySorting');
    }





    const setupData = () => {
        let columns = processColumnsNew(compRef.current.columns);
        compRef.current.columns = columns;
        let data_cols = [];
        columns.map((i) => {
            i.subcolumns.map((x) => {
                data_cols.push(x.value);
            });
        });
        compRef.current.data_cols = data_cols;
        let data_setup = processDataReports(columns, displayData, {
            auth,
            app_state,
            ui_state,
            state
        });
        // debugger;
        compRef.current.data_setup = deepCopy(data_setup);
        let t = compRef.current.sortedColumn;
        let date_dba = active_tiles[0] === 'bi_sensitivity_analysis' ? 'dba' : 'date';
        if (date_dba === 'date' && active_tiles[0] !== 'revpar_index') {
            data_setup = data_setup.filter((item) => item[0][date_dba] === '' || filteredDow.includes(moment(item[0].date).format('ddd').toLocaleLowerCase()) || filteredDow.includes('all'));
        }
        if (active_tiles[0] === 'revpar_index' && app_state.workspace_controls.tableType === 'daily') {
            data_setup = data_setup.filter((item) => item[0][date_dba] === '' || filteredDow.includes(moment(item[0].date).format('ddd').toLocaleLowerCase()) || filteredDow.includes('all'));
        }

        let sortedColumn = getSortedColumn(compRef.current.columns);
        data_setup = getFilteredData({ data: data_setup, columns });
        let finalRows = [];
        // debugger;
        if (active_tiles[0] === 'bi_sensitivity_analysis' && segmentType === 'hotel') {
            data_setup = getFilteredData({ data: data_setup, columns: compRef.current.columns });
        } else if (active_tiles[0] === 'otb_v2_multi_segment' && segmentType === 'hotel') {
            data_setup = getFilteredData({ data: data_setup, columns: compRef.current.columns });
        } else if (
            (ui_state.reports_dpbs.selectedCategory.includes("Hotel") && workspace_controls.segmented_view) ||
            (!ui_state.reports_dpbs.selectedCategory.includes("Hotel")) ||
            (active_tiles[0] === 'otb_v2_multi_segment' &&
                in_array([segmentType], ['top_market_segment', 'market_segment', 'room_class', 'room_type', 'rate_plan'])
            ) ||
            active_tiles[0] === 'bi_sensitivity_analysis'
        ) {
            data_setup = data_setup.filter((item) => (item[0][date_dba] === '' && filteredSegments.includes(item[0].segment)) || item[0].segment === 'Total' || filteredSegments.includes(item[0].segment) || filteredSegments.includes('all'));
            let totalsRows = data_setup.filter(item => item[0].segment === 'Total');
            // debugger;
            totalsRows.forEach(item => {
                let segmentedRows = data_setup.filter(d => item[0][date_dba] === d[0][date_dba] && d[0].segment !== 'Total');
                if (!workspace_controls.segmented_view) {
                    segmentedRows = getFilteredData({ data: segmentedRows, columns: compRef.current.columns });
                }
                if (segmentedRows.length > 0) {
                    let calcTotal = getTotalData(segmentedRows, 'segment');
                    if (active_tiles[0] === 'bi_sensitivity_analysis' && segmentType === 'market_segment') {
                        calcTotal.forEach((col, i) => {
                            let findTotalSaleRateEle = item.find(d => d.id === col.id);
                            col.SellRate = findTotalSaleRateEle.SellRate;
                        })
                    }
                    let totalOfFiltered = deepCopy([...[item[0]], ...calcTotal]);
                    totalOfFiltered.forEach((col, i) => {
                        if (item[i]) {
                            totalOfFiltered[i].id = item[i].id;
                            if (i > 0 && item[i]._vcap !== undefined) {
                                // _vcap itself must survive onto totalOfFiltered whenever present — not
                                // only when it differs from base Capacity — because downstream grand-
                                // total aggregation (getTotalData's effectiveVcap) reads _vcap off this
                                // row directly. Gating the copy on _vcapDiffers meant _vcap silently
                                // vanished here whenever VCapacity happened to equal Capacity for a date.
                                totalOfFiltered[i]._vcap = item[i]._vcap;
                                totalOfFiltered[i]._vcapLabel = item[i]._vcapLabel;
                                totalOfFiltered[i]._vcapDiffers = item[i]._vcapDiffers;

                                // variance_pickup's Rooms/Revenue here are already a current-minus-prior
                                // DIFFERENCE (not one snapshot), and its _vcap is a single snapshot's
                                // capacity — Rooms/_vcap is meaningless for a diff column (see the identical
                                // guard in setupData's copy of this block).
                                const isDiffColumn = item[i].id === 'variance_pickup';
                                if (!isDiffColumn && showVariableCapacity && item[i]._vcapDiffers) {
                                    totalOfFiltered[i].Occ = convertToPercent(totalOfFiltered[i].Rooms / totalOfFiltered[i]._vcap);
                                    totalOfFiltered[i].RevPAR = totalOfFiltered[i].Revenue / totalOfFiltered[i]._vcap;
                                }
                            }
                            if (i > 0 && showVariableCapacity && 'Available' in item[i] && item[i]._vcap !== undefined && typeof totalOfFiltered[i].Rooms === 'number') {
                                totalOfFiltered[i].Available = round(item[i]._vcap - totalOfFiltered[i].Rooms);
                            }
                        }
                    });
                    // Percentage-typed comparison columns (e.g. "% Variance to SDLY") can't be
                    // recomputed via the vcap-numeric path above because their Rooms field is
                    // itself a percentage string. Derive Available% instead from the TY/SDLY
                    // sibling columns' own Available, already fixed by the pass above.
                    totalOfFiltered.forEach((col, i) => {
                        if (item[i] && i > 0 && showVariableCapacity && 'Available' in item[i] &&
                            typeof totalOfFiltered[i].Rooms === 'string' && totalOfFiltered[i].Available === undefined) {
                            const tyCol = totalOfFiltered.find(c => c && (c.id === 'otb_current' || c.id === 'otb_primary_report'));
                            const sdlyCol = totalOfFiltered.find(c => c && c.id === 'otb_sdly');
                            if (tyCol && sdlyCol && typeof tyCol.Available === 'number' && typeof sdlyCol.Available === 'number' && sdlyCol.Available) {
                                const variancePct = (tyCol.Available - sdlyCol.Available) / sdlyCol.Available;
                                totalOfFiltered[i].Available = (variancePct && isFinite(variancePct)) ? convertToPercent(variancePct) + "%" : "0%";
                            } else {
                                totalOfFiltered[i].Available = "0%";
                            }
                        }
                    });
                    if (totalOfFiltered.length) {

                        if (workspace_controls.segmented_view) {
                            finalRows = [...finalRows, ...segmentedRows, ...[totalOfFiltered]];
                        } else {
                            finalRows = [...finalRows, ...[totalOfFiltered]];
                            finalRows = getFilteredData({ data: finalRows, columns: compRef.current.columns });

                        }

                        // if (workspace_controls.segmented_view) {
                        //     finalRows = [...finalRows, ...segmentedRows, ...[totalOfFiltered]];
                        // } else {
                        //     finalRows = [...finalRows, ...[totalOfFiltered]];
                        // }
                    }

                }
            });
            let finalSegmentsTotal = [];

            if (finalRows.length && workspace_controls.segmented_view) {
                filteredSegments = getUnique(filteredSegments);
                filteredSegments.forEach((item) => {
                    let segmentTotalRow = finalRows.filter((row) => row && row[0] && row[0].segment === item);
                    let dateCol = deepCopy(finalRows[0][0]);
                    if (date_dba === 'date') {
                        dateCol.date = '';
                        dateCol.dow = '';
                    }
                    if (date_dba === 'dba') {
                        dateCol.dba = '';
                    }
                    dateCol.segment = segments.map[item] ? segments.map[item] : item; dateCol.segment = item;

                    let calcTotal = getTotalData(segmentTotalRow, 'segmentTotal');

                    if (calcTotal.length) {
                        segmentTotalRow = [...[dateCol], ...getTotalData(segmentTotalRow, 'segmentTotal')];
                        finalSegmentsTotal = [...finalSegmentsTotal, ...[segmentTotalRow]];
                    }
                });
                finalRows = [...finalRows, ...finalSegmentsTotal];

            }
            data_setup = deepCopy(finalRows);
            data_setup = sortData({ data: data_setup, sortBy: sortedColumn.value, parent: sortedColumn.parent, order: sortedColumn.sorted, workspace_controls: app_state.workspace_controls });
        }
        else {
            data_setup = sortData({ data: data_setup, sortBy: sortedColumn.value, parent: sortedColumn.parent, order: sortedColumn.sorted, workspace_controls: app_state.workspace_controls });
            data_setup = getFilteredData({ data: data_setup, columns: compRef.current.columns });
        }
        // compRef.current.data_setup = deepCopy(data_setup);
        setDataSetup(data_setup);
        setCompLoadStatus('loaded');
    };

    const renderHeader = () => {
        let columns = compRef.current.columns;
        let cols = [];
        let colheaders = [];
        let count = 0;
        let bckgClass = "grey";
        for (let index = 0; index < columns.length; index++) {
            if (index > 0) {
                bckgClass = "light_blue";
            }

            const col = columns[index];
            // const col_len = col["subcolumns"].length;
            let colSpan = col["subcolumns"].length;
            let hiddenCols = col["subcolumns"].filter(item => item.hidden);
            colSpan = colSpan - hiddenCols.length;
            // debugger
            let primaryHSty = {};
            if (col.type == "dateColumn") {
                primaryHSty = {
                    position: "sticky",
                    left: col.left ? col.left : 0,
                    zIndex: 5,
                };
                // colSpan = 2;
            }
            colSpan = colSpan > 1 ? colSpan : null;
            const header = (
                <PrimaryHeaderCell
                    onDrop={col.type !== "dateColumn" ? mainColumnOnDropHandler(col) : undefined}
                    key={index}
                    align="center"
                    colSpan={colSpan}
                    style={primaryHSty}
                    className={"primary-header-cell header_col "}
                    sx={{ fontWeight: "bold !important" }}
                    data-fill-color="606060"
                    data-f-color="ffffff"
                    data-b-r-s="thin"
                    data-a-v="middle"
                    data-b-a-c="ffffff"
                    data-a-h="center"
                    data-f-sz="16"
                >
                    {col.draggable && <div draggable={!in_array(ui_state.active_tiles, DRAG_ICON_DISABLED_TILES) && col.draggable} onDragStart={!in_array(ui_state.active_tiles, DRAG_ICON_DISABLED_TILES) ? onDragStartHandler(col) : undefined} onDragOver={!in_array(ui_state.active_tiles, DRAG_ICON_DISABLED_TILES) ? (e) => { e.preventDefault() } : undefined} style={{ position: "relative", cursor: !in_array(ui_state.active_tiles, DRAG_ICON_DISABLED_TILES) ? "grab" : "default" }}>
                        {!in_array(ui_state.active_tiles, DRAG_ICON_DISABLED_TILES) && <DragIndicatorIcon style={{ position: "absolute", left: "2px", top: "50%", transform: "translateY(-50%)", fontSize: "14px", opacity: 0.6 }} />}
                        {/* <span>{col.display}</span> */}
                        {primaryHeaderDisplay(col, app_state, ui_state)}

                    </div>}

                    {!col.draggable && <div>
                        {/* <span>{col.display}</span> */}
                        {primaryHeaderDisplay(col, app_state, ui_state)}

                    </div>}

                </PrimaryHeaderCell>
            );
            let subcolumns = col["subcolumns"].map(item => item.value);
            const tableFilterCurrTile = ui_state.table_filters.table_common['kpis_hidden_' + ui_state.active_tiles[0]];
            col["subcolumns"].map((item, sub_col_index) => {
                bckgClass = ((item.display).toLowerCase() === "comparison date") ? "header-grey" : "header-blue";
                let segmentClass = ((item.display).toLowerCase() === "segment") ? "segment-class" : "";
                // debugger;
                let sty = {};
                // sty["paddingBottom"] = "18px";
                sty["fontWeight"] = "bold";
                sty["background"] = "#3fa7cd";
                sty["fontSize"] = "19px !important";
                sty["width"] = (item.value === "Roomsrate") ? "570px" : "";

                let segmentType = workspace_controls.segmentType;
                let hasFilterClass = item.filter && (item.filter.gte || item.filter.lte) ? "has-filter" : "";
                if (!hasFilterClass && !['dow', 'segment', 'date'].includes(item.type) && item.parent === col.id) {
                    let kpiHidden = tableFilterCurrTile && tableFilterCurrTile[item.parent] ? tableFilterCurrTile[item.parent] : [];
                    let is_hidden_kpis_in_table = kpiHidden.some(ele => subcolumns.includes(ele))

                    let isHiddenCol = col["subcolumns"].find(itm => itm.hidden);
                    if (segmentType === 'rate_plan') {
                        isHiddenCol = col["subcolumns"].find(itm => itm.hidden && itm.value !== 'RevPAR' && itm.value !== 'SellRate');
                    }

                    // if (isHiddenCol) {
                    //     hasFilterClass = "has-filter";
                    // }
                    if (is_hidden_kpis_in_table) {
                        hasFilterClass = "has-filter";
                    }
                    // 
                }
                if (['dow'].includes(item.type) && ui_state.table_filters.table_reports.dow.length < 7) {
                    hasFilterClass = "has-filter";
                }

                if (segmentType === "market_segment" && ['segment'].includes(item.type)) {
                    let activeSegment = ui_state.table_filters.table_reports.market_segment;
                    let segmentList = new Set(segments.list.map(item => item.name));
                    if (activeSegment[0].code !== "all" && activeSegment.length !== segmentList.size) {
                        hasFilterClass = segmentType + " has-filter";
                    }
                }
                if (segmentType === "rate_plan" && ['segment'].includes(item.type)) {
                    let activeSegment = ui_state.table_filters.table_reports.rate_plan;
                    let segmentList = getRatePlan();
                    if (activeSegment[0].code !== "all" && activeSegment.length !== segmentList.length) {
                        hasFilterClass = segmentType + " has-filter";
                    }
                }
                if (segmentType === "top_market_segment" && ['segment'].includes(item.type)) {
                    let activeSegment = ui_state.table_filters.table_reports.top_market_segment;
                    let segmentList = getTopSegments();
                    if (activeSegment[0].code !== "all" && activeSegment.length !== segmentList.length) {
                        hasFilterClass = segmentType + " has-filter";
                    }
                }
                if (segmentType === "room_class" && ['segment'].includes(item.type)) {
                    let activeSegment = ui_state.table_filters.table_reports.room_class;
                    let segmentList = getRoomClass();
                    if (activeSegment[0].code !== "all" && activeSegment.length !== segmentList.length) {
                        hasFilterClass = segmentType + " has-filter";
                    }
                }

                if (segmentType === "room_type" && ['segment'].includes(item.type)) {
                    let activeSegment = ui_state.table_filters.table_reports.room_type;
                    let segmentList = getRoomType();
                    if (activeSegment[0].code !== "all" && activeSegment.length !== segmentList.length) {
                        hasFilterClass = segmentType + " has-filter";
                    }
                }


                // debugger;
                let el = (
                    <SecondaryHeaderBlueCell
                        onDrop={col.type !== "dateColumn" ? dataColumnOnDropHandler(item) : undefined}
                        onDragOver={col.type !== "dateColumn" ? (e) => { e.preventDefault() } : undefined}
                        className={"header_col  " + bckgClass + " col_len_1  header-col-" + item.value}
                        style={sty}
                        key={count}
                        align="center"
                        data-fill-color="B2B2B2"
                        data-f-color="ffffff"
                        data-a-v="middle"
                        data-a-h="center"
                        data-f-bold="true"
                        data-f-sz="15"
                        // data-b-a-c="ffffff"
                        data-b-r-s="thin"
                        data-b-a-c="ffffff"
                        sx={{
                            fontSize: "13px", padding: "0px !important",
                            top: "30px !important", verticalAlign: "top"
                        }}>
                        <div className={"filter-position-r " + bckgClass + " " + segmentClass} onDragOver={col.type !== "dateColumn" ? (e) => { e.preventDefault() } : undefined}>
                            <ColumnSorting
                                className={"column-sorting field-" + item.value}
                                colItem={item} sortable={item.sortable} sorted={item.sorted}
                                label={item.display} value={item.value}
                                onOrderByChange={onOrderByChangeHandler} />

                            <div className="col-head-label" draggable={col.type !== "dateColumn" && item.draggable} onDragStart={col.type !== "dateColumn" ? onDragStartHandler(item) : undefined}>
                                {/* {item.display}----test */}
                                {showSegmentType(app_state, ui_state, item.display)}
                                {item.subDisplay && permissionDetails.permissions?.variable_capacity_enabled && <div style={{
                                    fontSize: '9.5px', fontWeight: 600, letterSpacing: '0.5px',
                                    textTransform: 'uppercase', color: '#FFD873', marginTop: '2px', whiteSpace: 'nowrap',
                                }}>{item.subDisplay}</div>}
                            </div>
                            {item.filterMenu &&
                                <div className={"filter-main " + item.type + " segment-type-" + segmentType}>
                                    {hasFilterClass && <span className={hasFilterClass}></span>}
                                    <Filter filteredColumns={compRef.current.filteredColumns} columnList={compRef.current.columns} currentColumn={item}
                                        segments={segments}
                                        columnToggleHandler={columnToggleHandler}
                                        applyFilterHandler={applyFilterHandler}
                                        clearFilterHandler={clearFilterHandler}
                                    />
                                </div>}
                        </div>
                    </SecondaryHeaderBlueCell>
                );


                if (col.type == "dateColumn") {
                    var colClass = "date_subcolumn";
                    sty["position"] = "sticky";
                    sty["zIndex"] = "5";
                    sty["textAlign"] = "center";
                    sty["paddingBottom"] = "18px";
                    sty["fontWeight"] = "bold";
                    sty["paddingLeft"] = "15px";
                    sty["paddingRight"] = "15px";
                    sty["background"] = "#b2b2b2";

                    if ((item.display).toLowerCase() === 'dba' || (item.display).toLowerCase() === 'month') {
                        sty["left"] = sub_col_index * 64;
                    }

                    if ((item.display).toLowerCase() === 'dow') {
                        // sty["left"] = "70px !important";
                        sty["width"] = "60px !important";
                    }
                    if ((item.display).toLowerCase() === 'segment' && ui_state.active_tiles[0].toLowerCase() !== "pace") {
                        sty["left"] = sub_col_index * 64;
                        sty["width"] = "120px !important";
                        colClass = "date_subcolumn_segment";
                    }

                    if ((item.display).toLowerCase() === 'segment' && app_state.workspace_controls.scopeType === "Dba" && ui_state.active_tiles[0].toLowerCase() === "pace") {
                        sty["left"] = sub_col_index * 80.5;
                        sty["width"] = "120px !important";
                        colClass = "date_subcolumn_segment";
                    }
                    if ((item.display).toLowerCase() === 'segment' && app_state.workspace_controls.scopeType === "Date" && ui_state.active_tiles[0].toLowerCase() === "pace") {
                        sty["left"] = sub_col_index * 74.5;
                        sty["width"] = "120px !important";
                        colClass = "date_subcolumn_segment";
                    }


                    <SecondaryHeaderGreyCell
                        className={"header_col  " + bckgClass + " " + colClass}
                        style={sty}
                        key={count}
                        align="left"
                        data-fill-color="3fa7cd"
                        data-f-color="ffffff"
                        data-a-v="middle"
                        data-a-h="center"
                        data-f-bold="true"
                        data-f-sz="15"
                        data-b-r-s="thin"
                        data-b-a-c="ffffff"
                        // sx={{pl:3.5,pr:13.5,pt:1}}
                        sx={{ fontSize: "13px", padding: "0px !important", top: "30px !important" }}
                    >
                        {/* <div className="filter-position-r">
                                {item.display}
                                <Filter className="filter-position-a" />
                            </div> */}
                        <div className="filter-position-r date-col" sx={{ minWidth: "80px !important" }}>
                            <div className="col-head-label">
                                {item.display}
                            </div>
                            <div className="filter-main">
                                <Filter />
                            </div>
                        </div>
                    </SecondaryHeaderGreyCell>
                }
                if (!item.hidden) {
                    cols.push(el);
                }
                count++;

            });
            if (!col.hidden) {
                colheaders.push(header);
            }

        }

        return (
            <>
                <TableRow data-height="30" className="header_row top_header">{colheaders}</TableRow>
                <TableRow data-height="30" className="header_row bottom_header">{cols}</TableRow>
            </>
        );
    };
    const renderBody = (params) => {
        // const data_setup = compRef.current.data_setup;
        const rows = [];
        const size = data_setup.length;
        var colCount = 0;
        var totalArr = [];
        var rowsCount = 0;
        var columnsCounts = 0;
        if (size > 0) {
            for (let index = 0; index < size; index++) {
                var evenRow = (rowsCount % 2 === 0) ? "even-row" : "";
                let columnTotal = 0;
                const data_columns = data_setup[index];
                const cols = [];
                const reportCols = [];
                let count = 0;
                totalArr[index] = 0;
                colCount = 0;
                var totalRow = "";
                var totalCol = "";
                var rowSegment = null;
                let rowDate;
                let dba = null;
                data_columns.map((column, col_index) => {
                    if (col_index === 0 && column.hasOwnProperty('dba')) {
                        dba = column.dba;
                    }
                    // console.log(compRef.current.columns[col_index]);
                    let subCols = (compRef.current.columns[col_index]) ? compRef.current.columns[col_index].subcolumns.filter(col => !col.hidden) : [];
                    // let subCols = Object.keys(column); debugger;
                    // Pickup columns carry their own (earlier) as-of date — the OOO/OOS popover must query that one.
                    const colAsOfDate = getColumnAsOfDate(compRef.current.columns[col_index]?.mainKey, app_state);

                    let cellClass = "data-cell";
                    subCols.map((subcol, sub_col_index) => {
                        let key = subcol.value;
                        let val = column[key];
                        let isTotalRow = column['segment'];
                        // debugger;
                        let txtAlignClass = (app_state.workspace_controls.segmented_view && key === 'Revenue') ? "text-align-right_x" : "";
                        let txtAlignClassml = (key === 'ADR' || key === 'Occ') ? "text-align-left-ml" : "";
                        let txtAlignClassRight = (key === 'Rooms') ? "" : "";

                        if (key === 'segment') {
                            rowSegment = val;
                            if (val === "Total") {
                                totalRow = "total-row";
                                totalCol = "total-col";
                            }
                        }
                        let sty = {};
                        if (col_index === 0) {
                            sty = { position: "sticky", zIndex: 1, textAlign: "left" };
                            sty["textAlign"] = "center";
                            if (key === "segment" && app_state.workspace_controls.scopeType === "Date" && ui_state.active_tiles[0].toLowerCase() === "pace") {
                                sty["left"] = sub_col_index * 74.5;
                                sty["borderRight"] = "solid 1px #ddd";
                                sty["borderCollapse"] = "collapse";
                            }
                            if (key === "segment" && app_state.workspace_controls.scopeType === "Dba" && ui_state.active_tiles[0].toLowerCase() === "pace") {
                                sty["left"] = sub_col_index * 80.5;
                                sty["borderRight"] = "solid 1px #ddd";
                            } else if (key === "segment" && ui_state.active_tiles[0].toLowerCase() !== "pace") {
                                sty["left"] = sub_col_index * 64;
                                sty["borderRight"] = "solid 1px #ddd";
                            }

                            else {
                                sty["left"] = sub_col_index * 94;
                                // sty["borderRight"] = "solid 10px #000";
                                // debugger; 
                                if ((!app_state.workspace_controls.segmented_view) && (key === "dow" || key === "date_market_summary" || key === "dba")) {
                                    sty["borderRight"] = "solid 1px #ddd";
                                    // sty["width"] = "solid 1px #ddd"; 
                                }
                                // if(app_state.workspace_controls.segmented_view) {
                                //     sty["borderRight"] = "solid 10px #ff0000";
                                // }
                            }
                        } else {
                            if (key.toLowerCase() === "revenue") {
                                // sty["color"] = "#3583B8";
                                sty["textAlign"] = "center";
                                sty["ml"] = "5px !important";
                                sty["padingLeft"] = "5px";
                            }
                        }
                        var txtAlign = { textAlign: "center" };
                        let rowsBackColor = (rowsCount % 2 === 0) ? "ebebeb" : "ffffff";
                        // var totalRow = "1";
                        let dataType = numberFormatForReport(key);
                        let reportData;
                        // if (!val)
                        let tmpVal;

                        if (val && typeof val === "number") {
                            tmpVal = val;
                        } else if (val && typeof val !== "object") {
                            tmpVal = val.replaceAll("%", "");
                        } else if (val && typeof val === "object") {
                            let resVal = (val[0]) ? Object.keys(val[0]).join(",") : "";
                            tmpVal = resVal;
                        }

                        if (key === 'date') {
                            reportData = (val) ? moment(val).format('YYYY/MM/DD') : '';
                            rowDate = reportData;
                        } else if (key === 'Revenue' || key === 'ADR' || key === 'Occ' || key === 'RevPAR') {
                            tmpVal = (tmpVal && isFinite(tmpVal) && !isNaN(tmpVal)) ? tmpVal : parseFloat(0.00);
                            reportData = tmpVal;//(Number.isFinite(tmpVal)) ? parseFloat(tmpVal).toFixed(2) : parseFloat(0.00).toFixed(2);
                        } else if (key === "Roomsrate") {
                            let repArr = [];
                            val.map((item) => {

                                repArr.push(item.room + "-" + item.changed_rate)
                            })
                            reportData = repArr.toString(",");
                            // debugger;

                        } else if (key === "RoomsRestrictions") {
                            reportData = "rest";
                        } else {
                            reportData = (tmpVal);
                        }
                        let brdRight;
                        let dowStyle
                        if (key === "dow") {
                            dowStyle = "dow-style";
                        }
                        if (key === "compdate") {
                            reportData = moment(val).format('MMM DD YYYY,  ddd');
                            dowStyle = "dow-style-comp-date";
                        }
                        if (key === "segment") {
                            dowStyle = "segment-td-style";
                        }

                        reportCols.push(
                            <TableCell
                                data-t={dataType.type}
                                // data-num-fmt={dataType.numfmt}
                                data-fill-color={rowsBackColor}
                                data-b-r-s="thin"
                                data-b-a-c="ffffff"
                                data-f-sz="12"
                                data-a-h="center"
                                key={count} className={cellClass + " " + totalCol}
                                style={sty}>{reportData}
                                {/* {reportData} - {key} */}
                                {/* <DisplayDataLogs displayValue={reportData} dataKey={key} displayType="report" /> */}
                            </TableCell>
                        );
                        cols.push(
                            // <Tooltip title={key} arrow>
                            <TableCell data-fill-color={rowsBackColor} data-b-r-s="thin" data-b-a-c="ffffff"
                                data-t="s" data-exclude="true" data-f-sz="13" data-a-h="center" key={count}
                                className={dowStyle + " " + brdRight + " " + cellClass + " " + totalCol + " " + txtAlignClass + " " + txtAlignClassml + " " + txtAlignClassRight}
                                style={key === 'Occ' ? { ...sty, position: 'relative' } : sty}>
                                {
                                    (key === 'Available' && ['otb_v2_multi_segment', 'bi_pace_comparison', 'bi_pickup_analysis', 'bi_sensitivity_analysis'].includes(ui_state.active_tiles[0]) && app_state.workspace_controls.segmented_view && totalRow !== 'total-row' && !(segmentType === 'room_class' || segmentType === 'room_type')) ?
                                        null
                                        :
                                        (ui_state.active_tiles[0] === "revpar_index") ?
                                            (key === "revpar_lift") ?
                                                parseFloat(val).toFixed(2) + "%"
                                                :
                                                displayDataFormat(val, key, "")
                                            :
                                            (key !== "compdate" && key !== "RoomsRestrictions" && key !== "date" && key !== "dow" && key !== "segment" && key != "month" && key != "date_market_summary" && key != "dba" && (typeof val === "string" || typeof val === "object")) ?
                                                <DisplayDataLogs displayValue={val} dataKey={key} displayType="table" />
                                                :
                                                <>
                                                    <DisplayData displayValue={displayDataFormat(val, key, "", ui_state.active_tiles[0])} dataKey={key} dataValue={val} stay_date={rowDate} isTotalRow={isTotalRow} />
                                                    {key === 'Occ' && active_tiles[0] !== 'bi_sensitivity_analysis' && (() => {
                                                        const isRowScopedVcap = totalRow !== 'total-row' && (segmentType === 'room_type' || segmentType === 'room_class');
                                                        if (!(!app_state.workspace_controls.segmented_view || totalRow === 'total-row' || segmentType === 'room_type' || segmentType === 'room_class')) return null;
                                                        return <VCapIndicator
                                                            vcap={isRowScopedVcap ? column._rtVcap : column._vcap}
                                                            vcapLabel={isRowScopedVcap ? column._rtVcapLabel : column._vcapLabel}
                                                            vcapDiffers={isRowScopedVcap ? column._rtVcapDiffers : column._vcapDiffers}
                                                            variableCapacityEnabled={permissionDetails.permissions.variable_capacity_enabled}
                                                            date={rowDate}
                                                            asOfDate={colAsOfDate}
                                                            roomType={(segmentType === 'room_type' && totalRow !== 'total-row') ? rowSegment : undefined}
                                                            roomTypes={(segmentType === 'room_class' && totalRow !== 'total-row') ? column._rtRoomTypes : undefined}
                                                            diffLookbackDays={(active_tiles[0] === 'bi_pickup_analysis' && column.id === 'variance_pickup') ? app_state.workspace_controls.pickUpDays : undefined}
                                                        />;
                                                    })()}
                                                    {/* {key === 'Available' && (!workspace_controls.segmented_view || isItTotalRow) && (active_tiles[0] === 'pace' && workspace_controls.scopeType === 'Dba') && <VCapIndicator vcap={column._vcap} vcapLabel={column._vcapLabel} vcapDiffers={column._vcapDiffers} variableCapacityEnabled={permissions.variable_capacity_enabled} stayDate={app_state.primary_stay_range.date_from} dba={rowDba} />} */}
                                                    {key === 'Occ' && active_tiles[0] === 'bi_sensitivity_analysis' && <VCapIndicator vcap={column._vcap} vcapLabel={column._vcapLabel} vcapDiffers={column._vcapDiffers} variableCapacityEnabled={permissionDetails.permissions.variable_capacity_enabled} stayDate={app_state.primary_stay_range.date_from} dba={dba} />}
                                                </>
                                    // displayDataFormat(val, key, "")
                                }
                            </TableCell>
                            // </Tooltip>
                        );
                        colCount++;

                        if (typeof val === 'string') {
                            //totalArr[count] = parseFloat(totalArr[count] + 0);
                        } else {
                            if (count === 4) {
                                if (totalArr[count] === 'undefind') {
                                    totalArr[count] = 0;
                                }
                            }
                            totalArr[count] += val;// parseFloat(totalArr[count] + val);
                        }
                        count += 1;
                    });
                    columnsCounts++;
                });
                //rows.push(<StyledTableRow data-exclude="true" data-height="20" className={(totalRow) ? totalRow : evenRow + " table-row"}>{cols}</StyledTableRow>);
                //rows.push(<StyledTableRow data-height="20" sx={{ display: "none" }} >{reportCols}</StyledTableRow>);
                rows.push(<>{cols}</>);

                rowsCount++;
            }
        } else {
            rows.push(<StyledTableRow className="">
                <TableCell colSpan={5}
                    sx={{ height: "auto", borderRight: "0px solid #ddd", background: "#fff", textAlign: "center", borderBottom: "0px solid" }}>
                    <Spinner />
                </TableCell></StyledTableRow>);
        }

        if (rowsCount <= 12) {
            let h = 30 * (12 - rowsCount) + 'px';
            rows.push(
                <><TableCell
                    sx={{ height: "auto", borderRight: "0px solid #ddd", background: "#fff", borderBottom: "0px solid" }}>
                    <div style={{ height: h }}></div>
                </TableCell></>);
        }

        let footerCols = [];
        var colSpanTotal = 2;
        let columns = processColumnsNew(compRef.current.columns);
        // if (data_setup.length > 0) {
        //     columns = data_setup[0];
        // }
        let count = 0;


        let multiSegmentOtbCurrent = {}
        let multiSegmentOtbSdly = {}

        columns.map((column, col_index) => {
            // let subCols = Object.keys(column);
            let subCols = compRef.current.columns[col_index].subcolumns.filter(col => !col.hidden);
            let frontColumn = Object.keys(column).length;
            // debugger;  
            if (col_index === 0) {
                footerCols.push(
                    <TableCell
                        colSpan={subCols.length}
                        className="data-cell"

                        data-b-r-s="thin"
                        data-b-a-c="ffffff"
                        data-a-h="center"
                        data-f-sz="15"
                        data-fill-color="b1e2f4"
                        data-f-color="000000"
                        data-f-bold="true"

                        key={Math.random()}
                        style={{
                            borderRight: "1px solid #ddd",
                            left: 0,
                            position: "sticky",
                            fontWeight: "bold",
                            zIndex: 5,
                            borderBottomLeftRadius: "6px",
                            textTransform: "capitalize",
                            fontSize: 14
                        }}
                    >
                        Total
                    </TableCell>
                );
            } else {
                if (ui_state.active_tiles[0].toLowerCase() === 'compset') {
                    subCols.map((key, sub_col_index) => {
                        var finalTotal;
                        let sty = {};
                        sty["background"] = "#606060 !important";
                        sty = { fontWeight: "bold" };
                        if (key.value.toLowerCase() === "revenue") {
                            sty["color"] = "#3583B8";
                        } else {
                            sty["color"] = "#fff !important";
                        }
                        footerCols.push(
                            <TableCell style={sty} className="data-cell"
                                data-b-r-s="thin"
                                data-b-a-c="ffffff"
                                data-a-h="center"
                                data-f-sz="14"
                                data-fill-color="b1e2f4"
                                data-f-color="000000"
                                data-f-bold="true"

                                key={Math.random()}>
                                {compsetTotal(data_setup, key.value, sub_col_index, count)}
                                {/* {
                    // (ui_state.active_tiles[0].toLowerCase() !== 'compset') ?
                    //   totalCalulate(data_setup, key, sub_col_index, count)
                    //   : compsetTotal(data_setup, key, sub_col_index, count)
                    } */}
                            </TableCell>
                        );
                    });
                }
                ///// for Market Sell rate Total row ////
                if (ui_state.active_tiles[0].toLowerCase() === 'market_sell_rates') {
                    subCols.map((key, sub_col_index) => {
                        var finalTotal;
                        let sty = {};
                        sty["background"] = "#606060 !important";
                        sty = { fontWeight: "bold" };
                        sty["color"] = "#fff !important";

                        footerCols.push(
                            <TableCell style={sty} data-b-r-s="thin"
                                data-b-a-c="ffffff"
                                data-a-h="center"
                                data-f-sz="14"
                                data-fill-color="b1e2f4"
                                data-f-color="000000"
                                data-f-bold="true" className="data-cell" key={Math.random()}>
                                {marketSellRatesTotal(data_setup, key, sub_col_index, count, ui_state)}

                            </TableCell>
                        );
                    });
                }

                if (ui_state.active_tiles[0].toLowerCase() !== 'compset' && ui_state.active_tiles[0].toLowerCase() !== 'market_sell_rates') {
                    let totalType = (app_state.workspace_controls.segmented_view) ? "Total" : "Total";
                    const totalData = getTotalData(data_setup);
                    let sty = {};
                    let dt1 = moment(app_state.primary_stay_range.date_from);
                    let dt2 = moment(app_state.primary_stay_range.date_until);
                    let daysCount = dt2.diff(dt1, 'days') + 1;

                    let system_settings = getAppData(auth, app_state);
                    let totalCapacity = system_settings.property_current_total_capacity;

                    let marketCapacity = (dataService.getSeriesById("MarketCapacity").data) ? dataService.getSeriesById("MarketCapacity").data.data : [];
                    let totalMarketCapacity = (marketCapacity && marketCapacity.length > 0) ? marketCapacity[marketCapacity.length - 1]['Capacity'] : 0;


                    let i = totalData[col_index - 1];

                    subCols.map((col) => {

                        /** make total calculation  */
                        if (active_tiles[0] === "otb_v2_multi_segment") {
                            if (col.parent === "otb_current") {
                                multiSegmentOtbCurrent[col.value] = i[col.value];
                            }
                            if (col.parent === "otb_sdly") {
                                multiSegmentOtbSdly[col.value] = i[col.value];
                            }

                            if (col.parent === "otb_variance_sdly") {
                                const _otbTY = totalData.find(t => t && t.id === 'otb_current');
                                const _otbSDLY = totalData.find(t => t && t.id === 'otb_sdly');
                                const _otbTYVal = (_otbTY && _otbTY[col.value] !== undefined) ? _otbTY[col.value] : multiSegmentOtbCurrent[col.value];
                                const _otbSDLYVal = (_otbSDLY && _otbSDLY[col.value] !== undefined) ? _otbSDLY[col.value] : multiSegmentOtbSdly[col.value];
                                let varianceResult = (_otbTYVal - _otbSDLYVal) / _otbSDLYVal;
                                i[col.value] = (varianceResult && isFinite(varianceResult)) ? convertToPercent(varianceResult) + "%" : "0.00" + "%";
                            }
                            // Available (otb_current/otb_sdly/otb_diff_sdly/otb_remaing_pickup_sdly) is
                            // now populated by getTotalData's effectiveVcap pass and otbTransformTotal's
                            // sumInventory pass — the same mechanisms Occ/RevPAR already rely on. A prior
                            // version summed each row's own Available directly here, which duplicated that
                            // logic and clobbered otb_variance_sdly's percentage value (set above) to 0.
                        }

                        if (['bi_pace_comparison', 'bi_pickup_analysis'].includes(active_tiles[0])) {
                            if (col.value === 'Available' && showVariableCapacity) {
                                let availableTotal = 0;
                                data_setup.forEach(items => {
                                    const isContributing = app_state.workspace_controls.segmented_view
                                        ? items[0]?.segment === 'Total' && items[0]?.date !== ''
                                        : items[0]?.date !== '';
                                    const colItem = items[col_index];
                                    if (isContributing && colItem && typeof colItem.Available === 'number') {
                                        availableTotal += colItem.Available;
                                    }
                                });
                                i['Available'] = availableTotal;
                            }
                        }

                        /** Pickup by Segment  */
                        // if(active_tiles[0] === "bi_pickup_analysis"){
                        if ((col.parent === "variance_pickup" || col.parent === "otb_sdly_pickup_var") && (col.display === "Occ" || col.display === "RevPAR")) {
                            if (!ui_state.showVariableCapacity) {
                                // i[col.value] = (col.value === "Occ") ? convertToPercent(i['Rooms'] / (totalCapacity * daysCount)) : i['Revenue'] / (totalCapacity * daysCount);
                            }
                            // When variable capacity is enabled, getTotalData computes Revenue / sum(VCapacity) via effectiveVcap from _vcap on each row
                        }
                        // }

                        /** end Pickup by segment  */
                        if (active_tiles[0] === "bi_pace_comparison") {
                            // if (col.parent === "otb_sdly_pickup_var") {
                            //     if (col.value === "ADR") {
                            //         i[col.value] = i['Revenue'] / i['Rooms'];
                            //     }
                            // }

                            /** Calculation for Occ and RevPAR (will Verify with Raghu and Atul )  */
                            // if ((col.parent === "otb_sdly_pickup_var") && (col.display === "Occ" || col.display === "RevPAR")) {
                            //     var dt1 = moment(app_state.primary_stay_range.date_from);
                            //     var dt2 = moment(app_state.primary_stay_range.date_until);
                            //     var daysCount = dt2.diff(dt1, 'days') + 1;

                            //     let system_settings = getAppData(auth, app_state);
                            //     let totalCapacity = system_settings.inventory_settings.current.total_capacity;

                            //     let pickupDaysCt = app_state.workspace_controls.pickUpDays;

                            //     let asOfDate = app_state.as_of_date;
                            //     let pickupDate = moment(asOfDate).subtract(pickupDaysCt, "days");

                            //     if (!pickupDate.isSameOrBefore(moment(dt1))) {
                            //         if (app_state.workspace_controls.pickUpDays > 1) {
                            //             let subsDays = parseInt(pickupDaysCt) + 1;
                            //             let pickupDaysCount = moment(app_state.as_of_date).subtract(subsDays, "days")
                            //             let finalDaysValue = daysCount - moment(pickupDaysCount).format("DD");
                            //             i[col.value] = (col.value === "Occ") ? convertToPercent(i['Rooms'] / (totalCapacity * finalDaysValue)) : i['Revenue'] / (totalCapacity * finalDaysValue);
                            //         } else {
                            //             let v = i[col.value] * daysCount;
                            //             let newdaysCount = getDaysForPickupOcc(app_state, ui_state);
                            //             i[col.value] = v / newdaysCount;
                            //         }
                            //     }

                            // }
                        }

                        /** end Total Calculation */

                        let occValue = (ui_state.active_tiles[0].toLowerCase() === 'pace') ? i.Occ / app_state.workspace_controls.dba : i.Occ;
                        let revParValue = (ui_state.active_tiles[0].toLowerCase() === 'pace') ? i.RevPAR / app_state.workspace_controls.dba : i.RevPAR;
                        revParValue = ((typeof revParValue).toLowerCase() === "string") ? revParValue : displayDataFormat(revParValue, "RevPAR", "");
                        let adrValue = ((typeof i.ADR).toLowerCase() === "string") ? i.ADR : displayDataFormat(i.ADR, "ADR", "");
                        footerCols.push(
                            <TableCell style={sty} className="data-cell" data-b-r-s="thin"
                                data-b-a-c="ffffff"
                                data-a-h="center"
                                data-f-sz="14"
                                data-fill-color="b1e2f4"
                                data-f-color="000000"
                                data-f-bold="true" key={Math.random()}>
                                {(col.value !== "date" && col.value !== 'dow' && col.value !== 'compdate') ?
                                    displayDataFormat(i[col.value], col.value, "")
                                    // i[col.value]
                                    : <></>
                                }
                            </TableCell>
                        )
                    })

                    // });
                }

            }
            count++;
        });

        rows.push(
            < >
                {in_array(ui_state.active_tiles, ["bi_sensitivity_analysis", "restrictions_push_status",
                    "revpar_index", "rm_room_type_ratesend_status", "DailyRatesendStatus"]) ? (
                    <></>
                ) : footerCols}

                {/* {
                (active_tiles[0] === "revpar_index" || bi_sensitivity_analysis) ? 
                <></> :
                footerCols
                
                } */}
            </>
        );

        return rows;
        //full table body is array of rows
        return <TableBody className="table-body">{rows}</TableBody>;
    };

    /////
    const getTotalData = (dataSet, type = 'Total') => {

        // if(type === 'segmentTotal') debugger;
        var date1 = moment(app_state.primary_stay_range.date_from);
        var date2 = moment(app_state.primary_stay_range.date_until);
        var daysCount = (type === 'segment') ? 1 : dataSet.length; //date2.diff(date1, 'days') + 1;
        //  daysCount = (type === 'Total') ? 1 : dataSet.length; //date2.diff(date1, 'days') + 1;
        if (type === 'Total') {
            daysCount = date2.diff(date1, 'days') + 1;
        }
        let dataArray = [];
        if (dataSet.length > 0) {
            // let keysArray = Object.keys(dataSet[0][1]);
            let dataObj = {}
            for (let j = 1; j < dataSet[0].length; j++) {
                let roomsTotal = 0;
                let occ = 0;
                let revPar = 0;
                let revenue = 0;
                let sellRate = 0;
                let total_sellRate;
                var total_sellRate_count = 0;
                let lenforSegment = 1;

                /// for variance 
                let varRoomsTotal = 0;
                let varRoomsSdlyTotal = 0;
                let varOccTotal = 0;
                let varOccSdlyTotal = 0;
                let varRevParTotal = 0;
                let varRevParSdlyTotal = 0;
                let varRevenueTotal = 0;
                let varRevenueSdlyTotal = 0;
                let varAdrTotal = 0;
                let varAdrSdlyTotal = 0;

                for (let i = 0; i < dataSet.length; i++) {
                    let items = dataSet[i];
                    if (app_state.workspace_controls.segmented_view) {
                        if (type === 'Total' && items[0] && items[0].segment === "Total" && items[0].date !== '') {
                            if (items[j] && Object.keys(items[j]).length) {
                                let total_sellRate = (items[j].SellRate !== '') ? items[j].SellRate : 0;
                                if (items[j].SellRate !== '') {
                                    total_sellRate = items[j].SellRate;
                                    total_sellRate_count++;
                                } else {
                                    total_sellRate = 0;
                                    total_sellRate_count++;
                                }
                                let adrTotal;
                                let primaryValtotal
                                if (typeof items[j].Rooms === "string") {
                                    // total for variance /////
                                    const _tyCol = items.find(col => col && (col.id === 'otb_current' || col.id === 'otb_primary_report')) || items[1];
                                    const _sdlyCol = items.find(col => col && col.id === 'otb_sdly') || items[2];
                                    varRoomsTotal += parseFloat(_tyCol.Rooms);
                                    varRoomsSdlyTotal += parseFloat(_sdlyCol.Rooms);

                                    varRevParTotal += parseFloat(_tyCol.RevPAR);
                                    varRevParSdlyTotal += parseFloat(_sdlyCol.RevPAR);
                                    let revParTmp = (varRevParTotal / total_sellRate_count);
                                    let revParSdlyTmp = (varRevParSdlyTotal / total_sellRate_count);

                                    varOccTotal += (_tyCol.Occ);
                                    varOccSdlyTotal += (_sdlyCol.Occ);
                                    let occTmp = (varOccTotal / total_sellRate_count);
                                    let occSdlyTmp = (varOccSdlyTotal / total_sellRate_count);

                                    varRevenueTotal += (_tyCol.Revenue);
                                    varRevenueSdlyTotal += (_sdlyCol.Revenue);
                                    let revenueTmp = (varRevenueTotal / total_sellRate_count);
                                    let revenueSdlyTmp = (varRevenueSdlyTotal / total_sellRate_count);

                                    varAdrTotal = (varRevenueTotal / varRoomsTotal);
                                    varAdrSdlyTotal = (varRevenueSdlyTotal / varRoomsSdlyTotal);
                                    roomsTotal = convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsSdlyTotal) + "%";
                                    occ = convertToPercent(((occTmp - occSdlyTmp) / occSdlyTmp)) + "%";
                                    revPar = convertToPercent((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal) + "%";
                                    revenue = convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueSdlyTmp)) + "%";
                                    adrTotal = convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal)) + "%";
                                } else {
                                    roomsTotal += getCorrectValue(items[j].Rooms);
                                    occ += getCorrectValue(items[j].Occ);
                                    revPar += getCorrectValue(items[j].RevPAR);
                                    revenue += getCorrectValue(items[j].Revenue);
                                    sellRate += getCorrectValue(total_sellRate);
                                    adrTotal = (revenue / roomsTotal);
                                    adrTotal = (isNaN(adrTotal) || !isFinite(adrTotal)) ? 0.00 : adrTotal;
                                }
                                dataObj = {
                                    "Rooms": roomsTotal,
                                    "Occ": occ,
                                    "RevPAR": revPar,
                                    "Revenue": revenue,
                                    "SellRate": sellRate,
                                    "ADR": adrTotal,
                                    "id": items[j].id
                                }
                                if ('SellRate' in items[j] === false) {
                                    delete dataObj["SellRate"];
                                }
                                if (Object.keys(items[j]).includes("Restrictions")) {
                                    dataObj = { "Restrictions": "" };
                                }
                            }
                            lenforSegment++;
                        }
                        if (type === 'segment' && items[0] && items[0].segment !== "Total" && items[0].date !== '') {
                            if (Object.keys(items[j]).length) {
                                let total_sellRate = (items[j].SellRate !== '') ? items[j].SellRate : 0;
                                if (items[j].SellRate !== '') {
                                    total_sellRate = items[j].SellRate;
                                    total_sellRate_count++;
                                } else {
                                    total_sellRate = 0;
                                    total_sellRate_count++;
                                }
                                let adrTotal;
                                let primaryValtotal
                                if (typeof items[j].Rooms === "string") {
                                    // total for variance /////
                                    const _tyCol = items.find(col => col && (col.id === 'otb_current' || col.id === 'otb_primary_report')) || items[1];
                                    const _sdlyCol = items.find(col => col && col.id === 'otb_sdly') || items[2];
                                    varRoomsTotal += parseFloat(_tyCol.Rooms);
                                    varRoomsSdlyTotal += parseFloat(_sdlyCol.Rooms);

                                    varRevParTotal += parseFloat(_tyCol.RevPAR);
                                    varRevParSdlyTotal += parseFloat(_sdlyCol.RevPAR);
                                    let revParTmp = (varRevParTotal / total_sellRate_count);
                                    let revParSdlyTmp = (varRevParSdlyTotal / total_sellRate_count);

                                    varOccTotal += (_tyCol.Occ);
                                    varOccSdlyTotal += (_sdlyCol.Occ);
                                    let occTmp = (varOccTotal / total_sellRate_count);
                                    let occSdlyTmp = (varOccSdlyTotal / total_sellRate_count);

                                    varRevenueTotal += (_tyCol.Revenue);
                                    varRevenueSdlyTotal += (_sdlyCol.Revenue);
                                    let revenueTmp = (varRevenueTotal / total_sellRate_count);
                                    let revenueSdlyTmp = (varRevenueSdlyTotal / total_sellRate_count);

                                    varAdrTotal = (varRevenueTotal / varRoomsTotal);
                                    varAdrSdlyTotal = (varRevenueSdlyTotal / varRoomsSdlyTotal);
                                    roomsTotal = convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsSdlyTotal) + "%";
                                    occ = convertToPercent(((occTmp - occSdlyTmp) / occSdlyTmp)) + "%";
                                    revPar = convertToPercent((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal) + "%";
                                    revenue = convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueSdlyTmp)) + "%";
                                    adrTotal = convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal)) + "%";
                                } else {
                                    roomsTotal += getCorrectValue(items[j].Rooms);
                                    occ += getCorrectValue(items[j].Occ);
                                    revPar += getCorrectValue(items[j].RevPAR);
                                    revenue += getCorrectValue(items[j].Revenue);
                                    sellRate += getCorrectValue(total_sellRate);
                                    adrTotal = (revenue / roomsTotal);
                                    adrTotal = (isNaN(adrTotal) || !isFinite(adrTotal)) ? 0.00 : adrTotal;
                                }
                                dataObj = {
                                    "Rooms": roomsTotal,
                                    "Occ": occ,
                                    "RevPAR": revPar,
                                    "Revenue": revenue,
                                    "SellRate": sellRate,
                                    "ADR": adrTotal,
                                    "id": items[j].id
                                }
                                if ('SellRate' in items[j] === false) {
                                    delete dataObj["SellRate"];
                                }
                                if (Object.keys(items[j]).includes("Restrictions")) {
                                    dataObj = { "Restrictions": "" };
                                }
                            }
                            lenforSegment++;
                        }
                        if (type === 'segmentTotal' && items[0] && items[0].segment !== "Total") {
                            if (Object.keys(items[j]).length) {
                                let total_sellRate = (items[j].SellRate !== '') ? items[j].SellRate : 0;
                                if (items[j].SellRate !== '') {
                                    total_sellRate = items[j].SellRate;
                                    total_sellRate_count++;
                                } else {
                                    total_sellRate = 0;
                                    total_sellRate_count++;
                                }
                                let adrTotal;
                                let primaryValtotal
                                if (typeof items[j].Rooms === "string") {
                                    // total for variance /////
                                    const _tyCol = items.find(col => col && (col.id === 'otb_current' || col.id === 'otb_primary_report')) || items[1];
                                    const _sdlyCol = items.find(col => col && col.id === 'otb_sdly') || items[2];
                                    varRoomsTotal += parseFloat(_tyCol.Rooms);
                                    varRoomsSdlyTotal += parseFloat(_sdlyCol.Rooms);

                                    varRevParTotal += parseFloat(_tyCol.RevPAR);
                                    varRevParSdlyTotal += parseFloat(_sdlyCol.RevPAR);
                                    let revParTmp = (varRevParTotal / total_sellRate_count);
                                    let revParSdlyTmp = (varRevParSdlyTotal / total_sellRate_count);

                                    varOccTotal += (_tyCol.Occ);
                                    varOccSdlyTotal += (_sdlyCol.Occ);
                                    let occTmp = (varOccTotal / total_sellRate_count);
                                    let occSdlyTmp = (varOccSdlyTotal / total_sellRate_count);

                                    varRevenueTotal += (_tyCol.Revenue);
                                    varRevenueSdlyTotal += (_sdlyCol.Revenue);
                                    let revenueTmp = (varRevenueTotal / total_sellRate_count);
                                    let revenueSdlyTmp = (varRevenueSdlyTotal / total_sellRate_count);

                                    varAdrTotal = (varRevenueTotal / varRoomsTotal);
                                    varAdrSdlyTotal = (varRevenueSdlyTotal / varRoomsSdlyTotal);
                                    roomsTotal = convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsSdlyTotal) + "%";
                                    // occ = (convertToPercent(((occTmp - occSdlyTmp) / occSdlyTmp)) / dataSet.length )+ "%"; 
                                    occ = (convertToPercent(((occTmp - occSdlyTmp) / occSdlyTmp))) + "%";
                                    revPar = convertToPercent((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal) + "%";
                                    revenue = convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueSdlyTmp)) + "%";
                                    adrTotal = convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal)) + "%";
                                } else {
                                    roomsTotal += getCorrectValue(items[j].Rooms);
                                    occ += getCorrectValue(items[j].Occ) / dataSet.length;
                                    revPar += getCorrectValue(items[j].RevPAR);
                                    revenue += getCorrectValue(items[j].Revenue);
                                    sellRate += getCorrectValue(total_sellRate);
                                    adrTotal = (revenue / roomsTotal);
                                    adrTotal = (isNaN(adrTotal) || !isFinite(adrTotal)) ? 0.00 : adrTotal;
                                }
                                dataObj = {
                                    "Rooms": roomsTotal,
                                    "Occ": occ,
                                    "RevPAR": revPar,
                                    "Revenue": revenue,
                                    "SellRate": sellRate,
                                    "ADR": adrTotal,
                                    "id": items[j].id
                                }
                                if ('SellRate' in items[j] === false) {
                                    delete dataObj["SellRate"];
                                }
                                if (Object.keys(items[j]).includes("Restrictions")) {
                                    dataObj = { "Restrictions": "" };
                                }
                            }
                            lenforSegment++;
                        }
                    } else {
                        if (type === 'Total' && items[0] && items[0].segment === "Total" && items[0].date !== '') {
                            if (items[j] && Object.keys(items[j]).length) {
                                let total_sellRate = (items[j].SellRate !== '') ? items[j].SellRate : 0;
                                if (items[j].SellRate !== '') {
                                    total_sellRate = items[j].SellRate;
                                    total_sellRate_count++;
                                } else {
                                    total_sellRate = 0;
                                    total_sellRate_count++;
                                }
                                let adrTotal;
                                let primaryValtotal
                                if (typeof items[j].Rooms === "string") {
                                    // total for variance /////
                                    const _tyCol = items.find(col => col && (col.id === 'otb_current' || col.id === 'otb_primary_report')) || items[1];
                                    const _sdlyCol = items.find(col => col && col.id === 'otb_sdly') || items[2];
                                    varRoomsTotal += parseFloat(_tyCol.Rooms);
                                    varRoomsSdlyTotal += parseFloat(_sdlyCol.Rooms);

                                    varRevParTotal += parseFloat(_tyCol.RevPAR);
                                    varRevParSdlyTotal += parseFloat(_sdlyCol.RevPAR);
                                    let revParTmp = (varRevParTotal / total_sellRate_count);
                                    let revParSdlyTmp = (varRevParSdlyTotal / total_sellRate_count);

                                    varOccTotal += (_tyCol.Occ);
                                    varOccSdlyTotal += (_sdlyCol.Occ);
                                    let occTmp = (varOccTotal / total_sellRate_count);
                                    let occSdlyTmp = (varOccSdlyTotal / total_sellRate_count);

                                    varRevenueTotal += (_tyCol.Revenue);
                                    varRevenueSdlyTotal += (_sdlyCol.Revenue);
                                    let revenueTmp = (varRevenueTotal / total_sellRate_count);
                                    let revenueSdlyTmp = (varRevenueSdlyTotal / total_sellRate_count);

                                    varAdrTotal = (varRevenueTotal / varRoomsTotal);
                                    varAdrSdlyTotal = (varRevenueSdlyTotal / varRoomsSdlyTotal);
                                    roomsTotal = convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsSdlyTotal) + "%";
                                    occ = convertToPercent(((occTmp - occSdlyTmp) / occSdlyTmp)) + "%";
                                    revPar = convertToPercent((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal) + "%";
                                    revenue = convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueSdlyTmp)) + "%";
                                    adrTotal = convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal)) + "%";
                                } else {
                                    roomsTotal += getCorrectValue(items[j].Rooms);
                                    occ += getCorrectValue(items[j].Occ);
                                    revPar += getCorrectValue(items[j].RevPAR);
                                    revenue += getCorrectValue(items[j].Revenue);
                                    sellRate += getCorrectValue(total_sellRate);
                                    adrTotal = (revenue / roomsTotal);
                                    adrTotal = (isNaN(adrTotal) || !isFinite(adrTotal)) ? 0.00 : adrTotal;
                                }
                                dataObj = {
                                    "Rooms": roomsTotal,
                                    "Occ": occ,
                                    "RevPAR": revPar,
                                    "Revenue": revenue,
                                    "SellRate": sellRate,
                                    "ADR": adrTotal,
                                    "id": items[j].id
                                }
                                if ('SellRate' in items[j] === false) {
                                    delete dataObj["SellRate"];
                                }
                                if (Object.keys(items[j]).includes("Restrictions")) {
                                    dataObj = { "Restrictions": "" };
                                }
                            }
                            lenforSegment++;
                        }
                        if (type === 'segment' && items[0] && items[0].segment !== "Total" && items[0].date !== '') {
                            if (Object.keys(items[j]).length) {
                                let total_sellRate = (items[j].SellRate !== '') ? items[j].SellRate : 0;
                                if (items[j].SellRate !== '') {
                                    total_sellRate = items[j].SellRate;
                                    total_sellRate_count++;
                                } else {
                                    total_sellRate = 0;
                                    total_sellRate_count++;
                                }
                                let adrTotal;
                                let primaryValtotal
                                if (typeof items[j].Rooms === "string") {
                                    // total for variance /////
                                    const _tyCol = items.find(col => col && (col.id === 'otb_current' || col.id === 'otb_primary_report')) || items[1];
                                    const _sdlyCol = items.find(col => col && col.id === 'otb_sdly') || items[2];
                                    varRoomsTotal += parseFloat(_tyCol.Rooms);
                                    varRoomsSdlyTotal += parseFloat(_sdlyCol.Rooms);

                                    varRevParTotal += parseFloat(_tyCol.RevPAR);
                                    varRevParSdlyTotal += parseFloat(_sdlyCol.RevPAR);
                                    let revParTmp = (varRevParTotal / total_sellRate_count);
                                    let revParSdlyTmp = (varRevParSdlyTotal / total_sellRate_count);

                                    varOccTotal += (_tyCol.Occ);
                                    varOccSdlyTotal += (_sdlyCol.Occ);
                                    let occTmp = (varOccTotal / total_sellRate_count);
                                    let occSdlyTmp = (varOccSdlyTotal / total_sellRate_count);

                                    varRevenueTotal += (_tyCol.Revenue);
                                    varRevenueSdlyTotal += (_sdlyCol.Revenue);
                                    let revenueTmp = (varRevenueTotal / total_sellRate_count);
                                    let revenueSdlyTmp = (varRevenueSdlyTotal / total_sellRate_count);

                                    varAdrTotal = (varRevenueTotal / varRoomsTotal);
                                    varAdrSdlyTotal = (varRevenueSdlyTotal / varRoomsSdlyTotal);
                                    roomsTotal = convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsSdlyTotal) + "%";
                                    occ = convertToPercent(((occTmp - occSdlyTmp) / occSdlyTmp)) + "%";
                                    revPar = convertToPercent((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal) + "%";
                                    revenue = convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueSdlyTmp)) + "%";
                                    adrTotal = convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal)) + "%";
                                } else {
                                    roomsTotal += getCorrectValue(items[j].Rooms);
                                    occ += getCorrectValue(items[j].Occ);
                                    revPar += getCorrectValue(items[j].RevPAR);
                                    revenue += getCorrectValue(items[j].Revenue);
                                    sellRate += getCorrectValue(total_sellRate);
                                    adrTotal = (revenue / roomsTotal);
                                    adrTotal = (isNaN(adrTotal) || !isFinite(adrTotal)) ? 0.00 : adrTotal;
                                }
                                dataObj = {
                                    "Rooms": roomsTotal,
                                    "Occ": occ,
                                    "RevPAR": revPar,
                                    "Revenue": revenue,
                                    "SellRate": sellRate,
                                    "ADR": adrTotal,
                                    "id": items[j].id
                                }
                                if ('SellRate' in items[j] === false) {
                                    delete dataObj["SellRate"];
                                }
                                if (Object.keys(items[j]).includes("Restrictions")) {
                                    dataObj = { "Restrictions": "" };
                                }
                            }
                            lenforSegment++;
                        }
                        if (type === 'segmentTotal' && items[0] && items[0].segment !== "Total") {
                            if (Object.keys(items[j]).length) {
                                let total_sellRate = (items[j].SellRate !== '') ? items[j].SellRate : 0;
                                if (items[j].SellRate !== '') {
                                    total_sellRate = items[j].SellRate;
                                    total_sellRate_count++;
                                } else {
                                    total_sellRate = 0;
                                    total_sellRate_count++;
                                }
                                let adrTotal;
                                let primaryValtotal
                                if (typeof items[j].Rooms === "string") {
                                    // total for variance /////
                                    const _tyCol = items.find(col => col && (col.id === 'otb_current' || col.id === 'otb_primary_report')) || items[1];
                                    const _sdlyCol = items.find(col => col && col.id === 'otb_sdly') || items[2];
                                    varRoomsTotal += parseFloat(_tyCol.Rooms);
                                    varRoomsSdlyTotal += parseFloat(_sdlyCol.Rooms);

                                    varRevParTotal += parseFloat(_tyCol.RevPAR);
                                    varRevParSdlyTotal += parseFloat(_sdlyCol.RevPAR);
                                    let revParTmp = (varRevParTotal / total_sellRate_count);
                                    let revParSdlyTmp = (varRevParSdlyTotal / total_sellRate_count);

                                    varOccTotal += (_tyCol.Occ);
                                    varOccSdlyTotal += (_sdlyCol.Occ);
                                    let occTmp = (varOccTotal / total_sellRate_count);
                                    let occSdlyTmp = (varOccSdlyTotal / total_sellRate_count);

                                    varRevenueTotal += (_tyCol.Revenue);
                                    varRevenueSdlyTotal += (_sdlyCol.Revenue);
                                    let revenueTmp = (varRevenueTotal / total_sellRate_count);
                                    let revenueSdlyTmp = (varRevenueSdlyTotal / total_sellRate_count);

                                    varAdrTotal = (varRevenueTotal / varRoomsTotal);
                                    varAdrSdlyTotal = (varRevenueSdlyTotal / varRoomsSdlyTotal);
                                    roomsTotal = convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsSdlyTotal) + "%";
                                    occ = convertToPercent(((occTmp - occSdlyTmp) / occSdlyTmp)) + "%";
                                    revPar = convertToPercent((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal) + "%";
                                    revenue = convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueSdlyTmp)) + "%";
                                    adrTotal = convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal)) + "%";
                                } else {
                                    roomsTotal += getCorrectValue(items[j].Rooms);
                                    occ += getCorrectValue(items[j].Occ);
                                    revPar += getCorrectValue(items[j].RevPAR);
                                    revenue += getCorrectValue(items[j].Revenue);
                                    sellRate += getCorrectValue(total_sellRate);
                                    adrTotal = (revenue / roomsTotal);
                                    adrTotal = (isNaN(adrTotal) || !isFinite(adrTotal)) ? 0.00 : adrTotal;
                                }
                                dataObj = {
                                    "Rooms": roomsTotal,
                                    "Occ": occ / dataSet.length,
                                    "RevPAR": revPar,
                                    "Revenue": revenue,
                                    "SellRate": sellRate,
                                    "ADR": adrTotal,
                                    "id": items[j].id
                                }
                                if ('SellRate' in items[j] === false) {
                                    delete dataObj["SellRate"];
                                }
                                if (Object.keys(items[j]).includes("Restrictions")) {
                                    dataObj = { "Restrictions": "" };
                                }
                            }
                            lenforSegment++;
                        }

                        if (type !== 'segment' && items[0] && items[0].segment !== "Total" && items[0].date !== '' && items[0].dba !== '') {
                            if (Object.keys(items[j]).length) {
                                let total_sellRate = (items[j].SellRate !== '') ? items[j].SellRate : 0;
                                if (items[j].SellRate !== '') {
                                    total_sellRate = items[j].SellRate;
                                    total_sellRate_count++;
                                } else {
                                    total_sellRate = 0;
                                    total_sellRate_count++;
                                }
                                let adrTotal;
                                let primaryValtotal
                                if (typeof items[j].Rooms === "string") {
                                    // total for variance /////
                                    const _tyCol = items.find(col => col && (col.id === 'otb_current' || col.id === 'otb_primary_report')) || items[1];
                                    const _sdlyCol = items.find(col => col && col.id === 'otb_sdly') || items[2];
                                    varRoomsTotal += parseFloat(_tyCol.Rooms);
                                    varRoomsSdlyTotal += parseFloat(_sdlyCol.Rooms);

                                    varRevParTotal += parseFloat(_tyCol.RevPAR);
                                    varRevParSdlyTotal += parseFloat(_sdlyCol.RevPAR);
                                    let revParTmp = (varRevParTotal / total_sellRate_count);
                                    let revParSdlyTmp = (varRevParSdlyTotal / total_sellRate_count);

                                    varOccTotal += (_tyCol.Occ);
                                    varOccSdlyTotal += (_sdlyCol.Occ);
                                    let occTmp = (varOccTotal / total_sellRate_count);
                                    let occSdlyTmp = (varOccSdlyTotal / total_sellRate_count);

                                    varRevenueTotal += (_tyCol.Revenue);
                                    varRevenueSdlyTotal += (_sdlyCol.Revenue);
                                    let revenueTmp = (varRevenueTotal / total_sellRate_count);
                                    let revenueSdlyTmp = (varRevenueSdlyTotal / total_sellRate_count);

                                    varAdrTotal = (varRevenueTotal / varRoomsTotal);
                                    varAdrSdlyTotal = (varRevenueSdlyTotal / varRoomsSdlyTotal);
                                    roomsTotal = convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsSdlyTotal) + "%";
                                    occ = convertToPercent(((occTmp - occSdlyTmp) / occSdlyTmp)) + "%";
                                    revPar = convertToPercent((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal) + "%";
                                    revenue = convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueSdlyTmp)) + "%";
                                    adrTotal = convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal)) + "%";
                                } else {
                                    roomsTotal += getCorrectValue(items[j].Rooms);
                                    occ += getCorrectValue(items[j].Occ);
                                    revPar += getCorrectValue(items[j].RevPAR);
                                    revenue += getCorrectValue(items[j].Revenue);
                                    sellRate += getCorrectValue(total_sellRate);
                                    adrTotal = (revenue / roomsTotal);
                                    adrTotal = (isNaN(adrTotal) || !isFinite(adrTotal)) ? 0.00 : adrTotal;
                                }
                                dataObj = {
                                    "Rooms": roomsTotal,
                                    "Occ": occ,
                                    "RevPAR": revPar,
                                    "Revenue": revenue,
                                    "SellRate": sellRate,
                                    "ADR": adrTotal,
                                    "id": items[j].id
                                }
                                if ('SellRate' in items[j] === false) {
                                    delete dataObj["SellRate"];
                                }
                                if (Object.keys(items[j]).includes("Restrictions")) {
                                    dataObj = { "Restrictions": "" };
                                }
                            }
                            lenforSegment++;
                        }
                    }
                }
                // When variable capacity is active, override OCC as sum(Rooms) / sum(vcap)
                let effectiveVcap = 0;
                // For diff-type columns (Variance to SDLY, Actuals LY vs SDLY), _vcap holds a
                // *difference* of two capacities, which legitimately sums to 0 (or negative) whenever
                // the compared periods share the same base capacity — the normal case. That's a real
                // answer, not "no data", so Available can't be gated on effectiveVcap > 0 the way
                // Occ/RevPAR are (those genuinely need a positive capacity to divide by). Track
                // whether _vcap was present at all instead.
                let vcapPresent = false;
                if (app_state.workspace_controls.segmented_view) {
                    if (type === 'Total') {
                        dataSet.forEach(items => {
                            if (items[0]?.segment === "Total" && items[0]?.date !== '' && items[j]?._vcap !== undefined) {
                                effectiveVcap += getCorrectValue(items[j]._vcap || 0);
                                vcapPresent = true;
                            }
                        });
                    } else if (type === 'segment') {
                        // All segments on same date share the same vcap — use last non-zero
                        dataSet.forEach(items => {
                            if (items[0]?.segment !== "Total" && items[0]?.date !== '' && items[j]?._vcap !== undefined) {
                                const v = getCorrectValue(items[j]._vcap || 0);
                                if (v > 0) effectiveVcap = v;
                                vcapPresent = true;
                            }
                        });
                    } else if (type === 'segmentTotal') {
                        dataSet.forEach(items => {
                            if (items[0]?.segment !== "Total" && items[j]?._vcap !== undefined) {
                                effectiveVcap += getCorrectValue(items[j]._vcap || 0);
                                vcapPresent = true;
                            }
                        });
                    }
                } else {
                    dataSet.forEach(items => {
                        if (items[j]?._vcap !== undefined) {
                            effectiveVcap += getCorrectValue(items[j]._vcap || 0);
                            vcapPresent = true;
                        }
                    });
                }
                if (effectiveVcap > 0 && typeof dataObj.Rooms === 'number') {
                    dataObj.Occ = convertToPercent(dataObj.Rooms / effectiveVcap);
                    dataObj.RevPAR = dataObj.Revenue / effectiveVcap;
                }
                if (vcapPresent && typeof dataObj.Rooms === 'number') {
                    // getTotalData otherwise never produces an Available field at all — derive it
                    // from the same _vcap totals Occ/RevPAR trust above. Note: for otb_current
                    // specifically, otbTransformTotal (functions.js) overrides Occ/RevPAR afterward
                    // using its own sumInventory value and must set Available the same way there, or
                    // this value gets silently superseded for that one column.
                    dataObj.Available = round(effectiveVcap - dataObj.Rooms);
                } else if (type === 'segmentTotal' && typeof dataObj.Rooms === 'number' &&
                    dataSet.some(items => items[j] && items[j].Available !== undefined)) {
                    // _vcap only ever lives on a date's "Total"-segment row (see
                    // getReportData_biSensitivitySegment), never on the individual-segment rows a
                    // "Total by Segment" row is built from — so vcapPresent above is always false
                    // here and Available is never set. The render path already blanks this cell for
                    // these rows regardless (segmented, non-total-row), but the export walks each
                    // row's own keys, so a missing property drops the cell entirely and shifts every
                    // later column left by one. Keep the key present so export alignment matches the
                    // header even though the display value is hidden either way. Gated on the source
                    // rows actually having an Available key — market columns (bi_pickup_analysis'/
                    // bi_pace_comparison's market_report etc.) never carry Available at all, so
                    // unconditionally adding it here created a phantom cell that generateTable's
                    // positional insertion then appended past the end of the row, landing under the
                    // Events/Event TY/Event SDLY header columns instead.
                    dataObj.Available = 0;
                }
                // let sellRateValue = (ui_state.active_tiles[0].toLowerCase() === 'market') ? 0 : '';
                let sRate = round(dataObj.SellRate / total_sellRate_count);
                if (sRate <= 0 && ui_state.active_tiles[0].toLowerCase() === 'market' && app_state.workspace_controls.scopeType === 'Dba') {
                    // sRate = "";
                }
                let adrTotal = dataObj.ADR;
                if (ui_state.active_tiles[0] === "market_summary" || ui_state.active_tiles[0] === "hotel_summary") {
                    daysCount = dataSet.length;
                    sRate = round(dataObj.SellRate / daysCount);
                }
                let occTotal = (type === 'Total' && effectiveVcap <= 0) ? dataObj.Occ / daysCount : dataObj.Occ;
                if (typeof dataObj.Occ !== "string" && typeof dataObj.RevPAR !== "string") {
                    var newValues = {
                        Occ: occTotal,
                        RevPAR: (effectiveVcap > 0) ? round(dataObj.RevPAR) : round(dataObj.RevPAR / daysCount),
                        SellRate: sRate,
                        Revenue: round(dataObj.Revenue),
                        ADR: round(dataObj.ADR)
                    }
                    dataObj = { ...dataObj, ...newValues };
                }
                if (dataObj.id === 'otb_end_sdly') {
                    // Blanking LY-actual SellRate is intentional here (averaging it across mixed
                    // segments/dates isn't meaningful) — but deleting the *key* rather than zeroing
                    // it means the export, which builds each row's cells positionally from
                    // Object.keys(item) with no header matching, drops the cell entirely and shifts
                    // every later column (the next group's Occ/Rooms/ADR/...) one column left. Keep
                    // the key present with a neutral value so export alignment matches the header,
                    // same as the render path already displays ($0.00) for this column.
                    dataObj.SellRate = 0;
                }
                dataArray.push(dataObj);
            }
        }

        //    console.log("dataArraydataArray ",dataArray);

        let marketTotalIndex = dataArray.findIndex((it) => it.id === "market_sdly_diff_report");
        if (marketTotalIndex >= 0) {
            let currentIndex = dataArray.findIndex((it) => it.id === "market_report");
            let sdlyIndex = dataArray.findIndex((it) => it.id === "market_sdly_report");
            if (dataArray[currentIndex] && dataArray[sdlyIndex].ADR) {
                dataArray[marketTotalIndex].ADR = dataArray[currentIndex].ADR - dataArray[sdlyIndex].ADR;
            }
        }
        let sdlyPickupTotalIndex = dataArray.findIndex((it) => it.id === "sdly_pickup_diff");
        if (sdlyPickupTotalIndex >= 0) {
            let currentIndex = dataArray.findIndex((it) => it.id === "sdly_actual");
            let sdlyIndex = dataArray.findIndex((it) => it.id === "sdly");
            if (dataArray[currentIndex] && dataArray[sdlyIndex].ADR) {
                dataArray[sdlyPickupTotalIndex].ADR = dataArray[currentIndex].ADR - dataArray[sdlyIndex].ADR;
            }
        }
        let sdlyPickupIndex = dataArray.findIndex((it) => it.id === "otb_sdly_pickup_var");
        if (sdlyPickupIndex >= 0) {
            let currentIndex = dataArray.findIndex((it) => it.id === "otb_end_sdly");
            let sdlyIndex = dataArray.findIndex((it) => it.id === "otb_sdly");
            if (dataArray[currentIndex] && dataArray[sdlyIndex].ADR) {
                dataArray[sdlyPickupIndex].ADR = dataArray[currentIndex].ADR - dataArray[sdlyIndex].ADR;
            }
        }

        let diffIndex = dataArray.findIndex((it) => it.id === "otb_diff_sdly");
        if (diffIndex >= 0) {
            let currentIndex = dataArray.findIndex((it) => it.id === "otb_primary_report");
            currentIndex = (currentIndex > -1) ? currentIndex : dataArray.findIndex((it) => it.id === "otb_current");
            let sdlyIndex = dataArray.findIndex((it) => it.id === "otb_sdly");
            if (dataArray[currentIndex] && dataArray[sdlyIndex].ADR) {
                dataArray[diffIndex].ADR = dataArray[currentIndex].ADR - dataArray[sdlyIndex].ADR;
            }
        }

        let diffTotalIndex = dataArray.findIndex((it) => it.id === "difference_sdly");
        if (diffTotalIndex >= 0) {
            let currentIndex = dataArray.findIndex((it) => it.id === "otb_primary_report");
            let sdlyIndex = dataArray.findIndex((it) => it.id === "sdly");
            if (dataArray[currentIndex] && dataArray[sdlyIndex].ADR) {
                dataArray[diffTotalIndex].ADR = dataArray[currentIndex].ADR - dataArray[sdlyIndex].ADR;
            }
        }

        let diffVarianceIndex = dataArray.findIndex((it) => it.id === "variance_pickup");
        if (diffVarianceIndex >= 0) {
            // let currentIndex = dataArray.findIndex((it) => it.id === "otb_primary_report");
            // let sdlyIndex = dataArray.findIndex((it) => it.id === "otb_pickup_report");
            // if (dataArray[currentIndex] && dataArray[sdlyIndex].ADR) {
            //     dataArray[diffVarianceIndex].ADR = dataArray[currentIndex].ADR - dataArray[sdlyIndex].ADR;
            // }
            let currentIndex = dataArray.findIndex((it) => it.id === "otb_primary_report");
            let priorIndex = dataArray.findIndex((it) => it.id === "otb_pickup_report");
            if (currentIndex >= 0 && priorIndex >= 0 && dataArray[currentIndex] && dataArray[priorIndex]) {
                dataArray[diffVarianceIndex].Occ = dataArray[currentIndex].Occ - dataArray[priorIndex].Occ;
                dataArray[diffVarianceIndex].RevPAR = dataArray[currentIndex].RevPAR - dataArray[priorIndex].RevPAR;
            }
            dataArray[diffVarianceIndex].ADR = dataArray[diffVarianceIndex].Revenue / dataArray[diffVarianceIndex].Rooms;
        }
        /** Calculation for Pickup and Market when mode = date  */
        // if(in_array(ui_state.active_tiles,["pickup","market"])){
        //         let system_settings = getAppData(auth, app_state);
        //         let totalCapacity = system_settings.inventory_settings.current.total_capacity;
        //         dataArray[0]['Occ'] = dataArray[0]['Rooms'] / (totalCapacity * 20) ;
        // }
        /** end  */

        if (ui_state.active_tiles[0] === "pace" && dataArray[1]) {
            let paceAdrDiff = dataArray[0]["ADR"] - dataArray[1]["ADR"];
            let paceRevparDiff = dataArray[0]["RevPAR"] - dataArray[1]["RevPAR"];

            dataArray.forEach((dataItem, i) => {
                if (i === 2) {
                    dataArray[i].ADR = paceAdrDiff;
                    dataArray[i].RevPAR = paceRevparDiff;
                }
            })
        }

        if (type === "Total") {
            dataArray = otbTransformTotal(dataArray, ui_state.active_tiles, workspace_controls, dataSet, showVariableCapacity);

        }
        return dataArray;
    }
    const getTotalData_10Oct = (dataSet) => {
        var date1 = moment(app_state.primary_stay_range.date_from);
        var date2 = moment(app_state.primary_stay_range.date_until);
        var daysCount = date2.diff(date1, 'days') + 1;
        const dataArray = [];
        if (dataSet.length > 0) {
            let keysArray = Object.keys(dataSet[0][1]);
            let dataObj = {}
            for (let j = 1; j < dataSet[0].length; j++) {
                let roomsTotal = 0;
                let occ = 0;
                let revPar = 0;
                let revenue = 0;
                let sellRate = 0;
                let total_sellRate;
                var total_sellRate_count = 0;
                let lenforSegment = 1;

                /// for variance 
                let varRoomsTotal = 0;
                let varRoomsSdlyTotal = 0;
                let varOccTotal = 0;
                let varOccSdlyTotal = 0;
                let varRevParTotal = 0;
                let varRevParSdlyTotal = 0;
                let varRevenueTotal = 0;
                let varRevenueSdlyTotal = 0;
                let varAdrTotal = 0;
                let varAdrSdlyTotal = 0;

                for (let i = 0; i < dataSet.length; i++) {
                    let items = dataSet[i];
                    if (items[0] && items[0].segment !== "Total" && items[0].date !== '' && items[0].dba !== '') {
                        if (Object.keys(items[j]).length) {
                            let total_sellRate = (items[j].SellRate !== '') ? items[j].SellRate : 0;
                            if (items[j].SellRate !== '') {
                                total_sellRate = items[j].SellRate;
                                total_sellRate_count++;
                            } else {
                                total_sellRate = 0;
                                total_sellRate_count++;
                            }
                            let adrTotal;
                            let primaryValtotal
                            if (typeof items[j].Rooms === "string") {
                                // total for variance /////
                                varRoomsTotal += parseFloat(items[1].Rooms);
                                varRoomsSdlyTotal += parseFloat(items[2].Rooms);

                                varRevParTotal += parseFloat(items[1].RevPAR);
                                varRevParSdlyTotal += parseFloat(items[2].RevPAR);
                                let revParTmp = (varRevParTotal / total_sellRate_count);
                                let revParSdlyTmp = (varRevParSdlyTotal / total_sellRate_count);

                                varOccTotal += (items[1].Occ);
                                varOccSdlyTotal += (items[2].Occ);
                                let occTmp = (varOccTotal / total_sellRate_count);
                                let occSdlyTmp = (varOccSdlyTotal / total_sellRate_count);

                                varRevenueTotal += (items[1].Revenue);
                                varRevenueSdlyTotal += (items[2].Revenue);
                                let revenueTmp = (varRevenueTotal / total_sellRate_count);
                                let revenueSdlyTmp = (varRevenueSdlyTotal / total_sellRate_count);

                                varAdrTotal = (varRevenueTotal / varRoomsTotal);
                                varAdrSdlyTotal = (varRevenueSdlyTotal / varRoomsSdlyTotal);
                                roomsTotal = convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsSdlyTotal) + "%";
                                occ = convertToPercent(((occTmp - occSdlyTmp) / occSdlyTmp)) + "%";
                                revPar = convertToPercent((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal) + "%";
                                revenue = convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueSdlyTmp)) + "%";
                                adrTotal = convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal)) + "%";
                            } else {
                                roomsTotal += (items[j].Rooms);
                                occ += parseFloat(items[j].Occ);
                                revPar += parseFloat(items[j].RevPAR);
                                revenue += parseFloat(items[j].Revenue);
                                sellRate += parseFloat(total_sellRate);
                                adrTotal = (revenue / roomsTotal);
                                adrTotal = (isNaN(adrTotal) || !isFinite(adrTotal)) ? 0.00 : adrTotal;
                            }
                            dataObj = {
                                "Rooms": roomsTotal,
                                "Occ": occ,
                                "RevPAR": revPar,
                                "Revenue": revenue,
                                "SellRate": sellRate,
                                "ADR": adrTotal //(revenue / roomsTotal)
                            }
                            if ('SellRate' in items[j] === false) {
                                delete dataObj["SellRate"];
                            }
                            if (Object.keys(items[j]).includes("Restrictions")) {
                                dataObj = { "Restrictions": "" };
                            }
                        }
                        lenforSegment++;
                    }
                }
                // let sellRateValue = (ui_state.active_tiles[0].toLowerCase() === 'market') ? 0 : '';
                let sRate = round(dataObj.SellRate / total_sellRate_count);
                if (sRate <= 0 && ui_state.active_tiles[0].toLowerCase() === 'market' && app_state.workspace_controls.scopeType === 'Dba') {
                    // sRate = "";
                }
                let adrTotal = dataObj.ADR;
                if (ui_state.active_tiles[0] === "market_summary" || ui_state.active_tiles[0] === "hotel_summary") {
                    daysCount = dataSet.length;
                    sRate = round(dataObj.SellRate / daysCount);
                }
                let occTotal = dataObj.Occ / daysCount;
                if (typeof dataObj.Occ !== "string" && typeof dataObj.RevPAR !== "string") {
                    var newValues = {
                        Occ: occTotal,
                        RevPAR: round(dataObj.RevPAR / daysCount),
                        SellRate: sRate,
                        Revenue: round(dataObj.Revenue),
                        ADR: round(dataObj.ADR)
                    }
                    dataObj = { ...dataObj, ...newValues };
                }
                dataArray.push(dataObj);
            }
        }

        if (ui_state.active_tiles[0] === "pace" && dataArray[1]) {
            let paceAdrDiff = dataArray[0]["ADR"] - dataArray[1]["ADR"];
            let paceRevparDiff = dataArray[0]["RevPAR"] - dataArray[1]["RevPAR"];

            dataArray.forEach((dataItem, i) => {
                if (i === 2) {
                    dataArray[i].ADR = paceAdrDiff;
                    dataArray[i].RevPAR = paceRevparDiff;
                }
            })
        }

        if (ui_state.active_tiles[0] === "bi_pace_comparison" && dataArray[7]) {
            let marketDiffAdr = dataArray[5]['ADR'] - dataArray[6]['ADR'];
            dataArray[7]['ADR'] = marketDiffAdr;
            dataArray[2]['ADR'] = dataArray[0]['ADR'] - dataArray[1]['ADR'];;
            dataArray[4]['ADR'] = dataArray[3]['ADR'] - dataArray[1]['ADR'];;
        }

        if (ui_state.active_tiles[0] === "bi_pickup_analysis" && dataArray[6]) {
            dataArray[6]['ADR'] = dataArray[4]['ADR'] - dataArray[5]['ADR'];;

        }

        return dataArray;
    }

    ////////
    /////////
    const compsetTotal = (obj, key, index, count) => {
        let total = 0;
        let daysInMonth = moment().daysInMonth();
        let totalDays = 0;
        for (let i = 0; i < obj.length; i++) {
            total = parseFloat(total + obj[i][count][key]);
            totalDays++;
        }
        total = (app_state.workspace_controls.scopeType !== 'Dba') ? round(total / totalDays) : round(total / 366);
        return displayDataFormat(total.toFixed(2), 'compset', '');
    };

    /////////




    const displayDataFormat = (val, key, type, tile = null) => {
        // if(!val){ val = 0; }
        key = key.toLowerCase();
        let value = val;
        let currSymbol = ui_state.currency_symbol;
        if (key === "available") {
            if (tile === "bi_sensitivity_analysis" && value === 0) {
                return "";
            }
            return val;
        }
        if (key === "roomsrestrictions") {
            return val;
        }
        if (val !== '' && key !== 'segment' && key !== 'compdate') {
            if (key.toLowerCase() !== "rooms" && key.toLowerCase() !== "dba" && key.toLowerCase() !== "revenue") {
                val = Number.isInteger(val) ? val.toFixed(2) : val;
            }
            if (type === "") {
                if (key === "date") {
                    val = moment(val).format("MMM DD");
                } else if (key === "dow" || key === "date_market_summary" || key === "month" || key === "dba") {
                    val = val;
                } else if (key === "occ" || key === "tcocc") {
                    val = parseFloat(val).toFixed(2) + "%";
                } else if (key === "sellrate") {
                    if (val && !val.toString().includes("%")) {
                        val = currSymbol + Math.round(val);
                    } else {
                        val = val;//currSymbol + Math.round(val);
                    }
                } else if ((key === "adr" || key === "revpar" || key === "sellrate_xx") && val !== "") {
                    // debugger;
                    if (val) {
                        if (!val.toString().includes("%") && (key.toLowerCase() === "sellrate" || key.toLowerCase() === "adr" || key.toLowerCase() === "revpar")) {
                            val = parseFloat(val);
                        }
                    }
                    if (typeof val !== "string" && (key === "sellrate" || key === "adr" || key === "revpar")) {
                        val = (!isFinite(val)) ? parseFloat(0.00).toFixed(2) : parseFloat(val).toFixed(2);
                        val = currSymbol + (val).toLocaleString_(undefined, { minimumFractionDigits: 2 });
                    } else {
                        val = val;
                    }

                } else if (key === "revenue") {
                    if (typeof val === "string") {
                        currSymbol = "";
                    }
                    if (val) {
                        val = currSymbol + (val).toLocaleString_({ minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    }
                } else if (key === "rooms") {
                    val = (val) ? val.toLocaleString_() : 0;
                } else {
                    val = currSymbol + val;
                }
            } else if (type !== "" && typeof val !== "string") {
                val = val + "%";
            }
            if (key !== "rooms" && key !== "dba") {

                if (value >= 0 || typeof value === "string") {
                    val = val;
                } else {
                    if (Number.isFinite(value)) {
                        val = "(" + val.toString().replaceAll("-", "") + ")";
                    } else {
                        val = currSymbol + parseFloat(0.00).toFixed(2);
                    }
                }

            }
        }
        if (key === 'segment') {
            val = truncate(val, 17);
        }
        if (key === "revpar_index" || key === "revpar_index_ly" || key === "sdly_revpar_index") {
            val = val.replaceAll('$', '');
        }
        if (key === 'compdate') {
            // let compVal =  dateFormat(val, "MMM DD, YYYY ddd");
            val = (val) ? dateFormat(val, "MMM DD YYYY,  ddd") : '';
            // debugger;
        }
        if (tile === "bi_sensitivity_analysis" && value === 0 && key !== "dba") {
            val = "";
        }

        return val;
    };

    const displayDataFormat_backup = (val, key, type) => {
        // if(!val){ val = "0.00"; }
        key = key.toLowerCase();
        let value = val;
        let currSymbol = ui_state.currency_symbol;
        if (val !== '' && key !== 'segment' && key !== 'compdate') {
            if (key.toLowerCase() !== "rooms" && key.toLowerCase() !== "dba" && key.toLowerCase() !== "revenue") {
                val = Number.isInteger(val) ? val.toFixed(2) : val;
            }
            if (type === "") {
                if (key === "date") {
                    val = moment(val).format("MMM DD");
                } else if (key === "dow" || key === "date_market_summary" || key === "month" || key === "dba") {
                    val = val;
                } else if (key === "occ" || key === "tcocc") {
                    val = parseFloat(val).toFixed(2) + "%";
                } else if ((key === "adr" || key === "revpar" || key === "sellrate") && val !== "") {
                    if (typeof val !== "string" || key === "sellrate" || key === "adr" || key === "revpar") {
                        val = (!isFinite(val)) ? parseFloat(0.00).toFixed(2) : parseFloat(val).toFixed(2);
                        val = currSymbol + (val).toLocaleString_(undefined, { minimumFractionDigits: 2 });
                    } else {
                        val = val;
                    }

                } else if (key === "revenue") {
                    if (typeof val === "string") {
                        currSymbol = "";
                    }
                    val = currSymbol + (val).toLocaleString_(undefined, { minimumFractionDigits: 2 });

                } else if (key === "rooms") {
                    val = val.toLocaleString_();
                } else {
                    val = currSymbol + val;
                }
            } else if (type !== "" && typeof val !== "string") {
                val = val + "%";
            }
            if (key !== "rooms" && key !== "dba") {

                if (value >= 0 || typeof value === "string") {
                    val = val;
                } else {
                    if (Number.isFinite(value)) {
                        val = "(" + val.toString().replaceAll("-", "") + ")";
                    } else {
                        val = currSymbol + parseFloat(0.00).toFixed(2);
                    }
                }

            }
        }
        if (key === 'segment') {
            val = truncate(val, 17);
        }
        if (key === 'compdate') {
            // let compVal =  dateFormat(val, "MMM DD, YYYY ddd");
            val = dateFormat(val, "MMM DD YYYY,  ddd");
            // debugger;
        }
        return val;
    };

    const totalCalulate = (obj, key, index, count) => {
        let dataIndex = index + 1;
        var total = 0;
        let symbol = "$";
        var totalRevenue = 0;
        for (let i = 0; i < obj.length; i++) {
            let dataInnerObj = obj[i][count];
            totalRevenue = parseFloat(total) + parseFloat(dataInnerObj.Revenue);
            if (key.toLowerCase() === "rooms") {
                symbol = "";
                total = parseFloat(total) + parseFloat(dataInnerObj.Rooms);
            }
            if (key.toLowerCase() === "occ") {
                symbol = "%";
                total = (parseFloat(total) + parseFloat(dataInnerObj.Occ)).toFixed(2);
            }
            if (key.toLowerCase() === "adr") {
                total = (parseFloat(total) + parseFloat(dataInnerObj.ADR)).toFixed(2);
            }
            if (key.toLowerCase() === "revpar") {
                total = (parseFloat(total) + parseFloat(dataInnerObj.RevPAR)).toFixed(
                    2
                );
            }
            if (key.toLowerCase() === "revenue") {
                total = (parseFloat(total) + parseFloat(dataInnerObj.Revenue));
            }
            if (key.toLowerCase() === "sellrate" && dataInnerObj.SellRate !== "") {
                total = parseFloat(total) + parseFloat(dataInnerObj.SellRate);
            }
        }

        if (
            key.toLowerCase() === "adr" ||
            key.toLowerCase() === "occ" ||
            key.toLowerCase() === "sellrate" ||
            key.toLowerCase() === "revpar"
        ) {
            total = (total / 12);
        }
        return displayDataFormat(round(total), key, "");
    };

    const calculateColWidth = (tile) => {
        let colWidth = [];
        let dataColumn = (tile === "compset") ? 20 : 12;
        for (let i = 1; i <= data_cols.length; i++) {
            if (i <= 2) {
                colWidth.push(10);
            } else {
                colWidth.push(dataColumn)
            }
        }
        return (colWidth.toString()).trim();
    }

    const hasInfoBoxReportTable = () => {
        let infoText = false;
        const { segmentType } = app_state.workspace_controls
        // console.log(ui_state.active_tiles[0]);
        // debugger;
        if (permissionDetails.permissions.rate_plan === 0 && segmentType === "rate_plan" && ui_state.active_tiles[0] === "otb_v2_multi_segment") {
            infoText = 'Rate Plan is not enabled for this property! Please contact success@lodgiq.com for further details.';
            // return true;
        }
        if (permissionDetails.permissions.room_type === 0 && segmentType === "room_type" && ui_state.active_tiles[0] === "otb_v2_multi_segment") {
            infoText = 'Room Type is not enabled for this property! Please contact success@lodgiq.com for further details.';
            // return true;
        }
        if (permissionDetails.permissions.room_type === 0 && segmentType === "room_class" && ui_state.active_tiles[0] === "otb_v2_multi_segment") {
            infoText = 'Room Class is not enabled for this property! Please contact success@lodgiq.com for further details.';
            // return true;
        }

        // let prop_mapping = getSeriesById('GetRateCodeMapping');
        let system_settings = getAppData(auth, app_state);
        let prop_mapping = system_settings.market_segment_category_mapping;
        if (in_array(ui_state.active_tiles, ['otb_v2_multi_segment', 'bi_pace_comparison', 'bi_pickup_analysis']) && Object.keys(prop_mapping).length === 0) {
            infoText = 'Property Segments are not Mapped in the RMS. Please update via Property Settings';
        }
        return infoText;
    }


    let footerRowClass = (ui_state.reports_dpbs.selectedCategory.includes("Hotel")) ? "report-filter" : "report-filter-segments";
    footerRowClass = (ui_state.active_tiles[0] === "bi_pace_comparison" || ui_state.active_tiles[0] === "bi_pickup_analysis") ? footerRowClass : "";

    if (['loaded', 'sortedCols'].includes(compLoadStatus) && compLoad && displayData.length && data_setup.length) {
        let newRenderBodyData = renderBody({ data_setup: data_setup });
        setRenderBodyData(newRenderBodyData);
        setCompLoadStatus('loaded..');
    }

    let noScroll = ui_state.active_tiles[0] === "rm_room_type_ratesend_status" ? "" : "no-scroll ";
    let tableContClass = renderBodyData.length < 12 ? `table-scrollable ${noScroll}` : "table-scrollable ";
    tableContClass += ` ${footerRowClass} `
    const TableComponentsValue = useCallback(TableComponents(tableContClass, active_tiles_className, data_setup, app_state), [tableContClass, active_tiles_className, data_setup])

    function changeScrollPosition(direction) {
        let indexToScroll = data_setup.length;
        if (segmented_view) {
            if (app_state.workspace_controls.scopeType === 'Date') {
                indexToScroll = _.findIndex(data_setup, function (item) { return item[0].date == "" });
                if (active_tiles[0] === "bi_sensitivity_analysis") {
                    indexToScroll = _.findIndex(data_setup, function (item) { return item[0].dba === '' });
                }
            }
        }
        if (direction === "up") {
            tableVirtuoso.current.scrollToIndex({
                index: 0,
                align: "start",
                behavior: "auto"
            });
            setTimeout(() => {
                setIsAtBottom(false);
            }, 10);
        }
        else {
            tableVirtuoso.current.scrollToIndex({
                index: indexToScroll - 1,
                align: "start",
                behavior: "auto"
            });
            setTimeout(() => {
                setIsAtBottom(true);
            }, 10);
        }
        return false;
    }

    function handleScroll(event) {
        const { scrollTop, scrollHeight, offsetHeight } = event.target;
        if (!segmented_view) {
            if (scrollTop + offsetHeight >= scrollHeight) {
                setIsAtBottom(true);
            }
            else if (scrollTop === 0) {
                setIsAtBottom(false);
            }
        }
        else {
            const remainingScroll = scrollHeight - (scrollTop + offsetHeight);
            const atBottom = remainingScroll <= offsetHeight;
            setIsAtBottom(atBottom);
        }
    }


    return (
        <Paper sx={{ width: "100%" }} elevation={0}>
            {/* <button onClick={onDownload} className="primary"> Download</button> */}
            {((ui_state.active_tiles[0] === "bi_pickup_analysis" || ui_state.active_tiles[0] === "bi_pace_comparison") && !hasInfoBoxReportTable()) ? <ReportFilter applyFilterHandler={applyFilterHandler} /> : ""}
            {!hasInfoBoxReportTable() && (
                <>
                    {
                        (compLoadStatus === 'sortingCols' && compLoad && displayData.length && data_setup.length) ? <Alert sx={{ position: 'absolute', width: 'calc(100% - 8px)', zIndex: 999, textAlign: 'center', opacity: 0.95, borderRadius: 0, lineHeight: 1, p: 0, pl: 1, left: 0, top: 80 }} severity="info" color='info' textAlign='center' icon={false}>Sorting data...</Alert> : ''
                    }
                    <TableVirtuoso
                        ref={tableVirtuoso}
                        onScroll={handleScroll}
                        data={renderBodyData.length ? new Array(renderBodyData.length - 1) : [1]}
                        components={TableComponentsValue}
                        fixedHeaderContent={() => (
                            renderHeader()
                        )}
                        fixedFooterContent={!renderBodyData.length > 3 ?
                            () => (<></>)
                            :
                            () => (
                                <TableRow sx={{
                                    position: "sticky",
                                    bottom: 0,
                                    zIndex: 3,
                                    backgroundColor: "#fff",
                                }}
                                    className="table-row footer-row">
                                    {renderBodyData.length && data_setup.length ? renderBodyData[renderBodyData.length - 1] : []}
                                </TableRow>
                            )}

                        itemContent={
                            (index) => (
                                ((compLoadStatus === 'loaded..' || compLoadStatus === 'sortedCols') && compLoad && displayData.length && data_setup.length) ?
                                    renderBodyData[index]
                                    :
                                    ((index === 0 ? (
                                        <TableCell colSpan={8} sx={{ p: 0, borderBottom: 'none', position: 'absolute', width: '100%' }}>
                                            <Alert severity="info">
                                                {['bi_pace_comparison', 'bi_pickup_analysis'].includes(active_tiles[0]) && <AlertTitle>Top Segments are not set for this data source in the property settings, please contact success@lodgiq.com for further details.</AlertTitle>}
                                                {!['bi_pace_comparison', 'bi_pickup_analysis'].includes(active_tiles[0]) && <AlertTitle>No data found</AlertTitle>}
                                            </Alert>
                                        </TableCell>
                                    ) : null))
                            )
                        }
                    />
                </>
            )}

            {shouldShowAutoScroll(renderBodyData.length) && <Box className="scroll-top-bottom-button" onClick={() => changeScrollPosition(!isAtBottom ? 'down' : 'up')}>
                <Tooltip title={isAtBottom ? "Scroll to Top" : "Scroll to Bottom"} arrow>
                    <svg
                        style={{
                            transform: !isAtBottom ? 'rotate(0deg)' : 'rotate(180deg)',
                            transition: 'transform 0.3s ease'
                        }}
                        xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000000" viewBox="0 0 256 256">
                        <path d="M213.66,130.34a8,8,0,0,1,0,11.32l-80,80a8,8,0,0,1-11.32,0l-80-80a8,8,0,0,1,11.32-11.32L128,204.69l74.34-74.35A8,8,0,0,1,213.66,130.34Zm-91.32,11.32a8,8,0,0,0,11.32,0l80-80a8,8,0,0,0-11.32-11.32L128,124.69,53.66,50.34A8,8,0,0,0,42.34,61.66Z"></path>
                    </svg>
                </Tooltip>
            </Box>}

            {hasInfoBoxReportTable() && <Box sx={{ p: 1 }}>
                <Alert severity="info">
                    <AlertTitle>Info</AlertTitle>
                    {hasInfoBoxReportTable()}
                </Alert>
            </Box>}

        </Paper>
    );
}

export default TableReports;

const TableComponents = (tableContClass, active_tiles_className, data_setup, app_state) => ({

    Scroller: React.forwardRef((props, ref) => <TableContainer component={Paper} {...props} style={{ ...props.style, scrollPaddingLeft: '460px', scrollPaddingBlock: '120px 30px' }} ref={ref} className={`${tableContClass} `} />), //className={"table-scrollable table-scrollable report-filter" +   'footerRowClass'}
    Table: (props) => <Table {...props} id="mainTable" stickyHeader size="small" aria-label="a dense table" className={active_tiles_className + " react-dynamic-table"} />,
    TableHead: React.forwardRef((props, ref) => <TableHead ref={ref} {...props} className="table-head" style={{ ...props.style, zIndex: 2 }} />),
    TableRow: (props) => {
        let ind = props['data-index'];
        let item = data_setup && data_setup.length ? data_setup[ind] : {};
        let allRowSegmentsHaveTotal = false;
        if (data_setup && data_setup.length && data_setup.length > 2) {
            allRowSegmentsHaveTotal = data_setup[0][0].segment === 'Total' && data_setup[1][0].segment === 'Total'
        }
        let total_row = item && item[0] && item[0].segment === 'Total' && !allRowSegmentsHaveTotal ? ' total-row' : '';
        return (<TableRow  {...props} className={`${props['data-index'] % 2 ? 'table-row even-row' + total_row : 'table-row odd-row' + total_row}`} />);
    },
    TableBody: React.forwardRef((props, ref) => <TableBody className="table-body" {...props} ref={ref} />),
})

const TableRowSet = (props) => {
    // debugger; 
    const { app_state, ui_state } = useSelector(
        (state) => state.app.current_state
    );
    let { dataSet } = props;
    let tm = props.compRef;

    const dispatch = useDispatch();
    const [renderCount, setRenderCount] = useState(1);
    const chunkLength = 50;
    const dataSize = dataSet.length;
    let totalRow = dataSet.slice(-1);
    const compRef = useRef({
        intervalId: null,
        renderItems: (dataSize > chunkLength) ? dataSet.slice(0, chunkLength).concat(totalRow) : dataSet,
        chunks: Math.ceil(dataSize / chunkLength),
        index: 1,
        renderCount: 0
    });

    useEffect(() => {
        let isSubscribed = true;
        if (compRef.current.index >= compRef.current.chunks) {
            clearInterval(compRef.current.intervalId);
            // debugger
            if (app_state.workspace_controls.disableExport) {
                // debugger;
                dispatch({
                    type: UPDATE_STATE,
                    payload: {
                        app_state: {
                            workspace_controls: { ...app_state.workspace_controls, disableExport: false }
                        }
                    }
                })
                // dispatch(updateAppState("exportStatus", {
                //     app_state: {
                //         workspace_controls: { ...app_state.workspace_controls, disableExport: false }
                //     }
                // }));
            }

        }
        return () => (isSubscribed = false);
    }, [renderCount]);

    useEffect(() => {

        let isSubscribed = true;
        if (compRef.current.chunks > 1) {
            dispatch(updateAppState("exportStatus", {
                app_state: {
                    workspace_controls: { ...app_state.workspace_controls, disableExport: true }
                }
            }));
            compRef.current.intervalId = setInterval(() => {
                compRef.current.renderItems.splice(-1);
                let newArray = dataSet.slice(chunkLength * compRef.current.index, chunkLength * (compRef.current.index + 1));
                if (compRef.current.chunks === compRef.current.index + 1) {
                    compRef.current.renderItems = compRef.current.renderItems.concat(newArray);
                } else {
                    compRef.current.renderItems = compRef.current.renderItems.concat(newArray, totalRow);
                }

                compRef.current.renderCount = compRef.current.index;
                setRenderCount(compRef.current.index);
                compRef.current.index++;
            }, 90);
            return () => clearInterval(compRef.current.intervalId);
        }
        return () => (isSubscribed = false);
    }, []);

    if (!compRef.current.renderItems.length) {
        return (
            <>Loading...</>
        );
    }
    let ri = compRef.current.renderItems;
    // debugger;
    return (compRef.current.renderItems)
};

//Helper functions
const getFilteredData = (params) => {
    // debugger;
    // {data:data_setup, sortBy: 'Occ', parent: 'otb_prior'};
    const { data, columns } = params;
    const filteredColumns = getFilteredColumns(columns);
    let filtereddData = deepCopy(data);
    if (!filteredColumns.length) {
        return filtereddData;
    }
    // debugger
    filtereddData = [];
    let pushedRow = [];
    data.map((row, i) => {
        for (let j = 0; j < row.length; j++) {
            for (let k = 0; k < filteredColumns.length; k++) {
                let { parent, value, filter } = filteredColumns[k];
                if (row[j].id === parent) {
                    // debugger
                    let rowData = null;
                    if (filter) {
                        let dataValue = row[j][value];
                        if (typeof dataValue !== 'number' && dataValue.indexOf('%') !== -1) {
                            dataValue = Number(dataValue.replaceAll(/%/g, ''));
                        }
                        if (filter.gte && filter.lte) {
                            if (dataValue >= Number(filter.gte) && dataValue <= filter.lte) {
                                rowData = row;
                            }
                        } else {
                            if (filter.gte && dataValue >= Number(filter.gte)) {
                                rowData = row;
                            }
                            if (filter.lte && dataValue <= filter.lte) {
                                rowData = row;
                            }
                        }

                        if (pushedRow.indexOf(i) === -1 && rowData) {
                            filtereddData.push(rowData);
                            pushedRow.push(i);
                        }
                    }
                }
            }
        }
    });
    // debugger;
    return filtereddData;
}


const sortData = (params) => {
    // {data:data_setup, sortBy: 'Occ', parent: 'otb_prior'};
    const { data, sortBy, parent, order, workspace_controls } = params;
    const sortedData = deepCopy(data);
    let finalSortedData = [];
    if (!order) {
        return sortedData;
    }
    let sortedParentIndex = null;
    if (sortedData[0]) {
        sortedData[0].map((item, i) => {
            if (item?.id === parent) {
                sortedParentIndex = i;
            }
        });
        let weekdaysShort = moment.weekdaysShort();
        // debugger;
        let sortedDates = [];
        let tempSortedDates = deepCopy(sortedData);
        let tempSortedDatesTotal = [];
        let tempSortedDatesBlank = [];
        let dba_date = workspace_controls.scopeType.toLowerCase();
        if (workspace_controls.segmented_view) {
            tempSortedDatesTotal = deepCopy(sortedData.filter(d => d[0].segment === 'Total'));
            tempSortedDates = deepCopy(sortedData.filter(d => d[0][dba_date] !== '' && d[0].segment !== 'Total'));
            tempSortedDatesBlank = deepCopy(sortedData.filter(d => d[0][dba_date] === ''));
            tempSortedDatesTotal = arraySort(tempSortedDatesTotal);

        } else {
            tempSortedDates = arraySort(sortedData);
            // deepCopy(sortedData);
        }

        function arraySort(arr) {
            let arr_copy = deepCopy(arr);
            arr_copy.sort((a, b) => {
                if (sortedParentIndex !== null) {
                    let A = a[sortedParentIndex][sortBy];
                    let B = b[sortedParentIndex][sortBy];
                    //This is added for Pickup variance to sdly column
                    A = (A) ? A : 0;
                    B = (B) ? B : 0;

                    if (typeof A !== 'number' && A.indexOf('%') !== -1) {
                        A = Number(A.replaceAll(/%/g, ''));
                    }
                    if (typeof B !== 'number' && B.indexOf('%') !== -1) {
                        B = Number(B.replaceAll(/%/g, ''));
                    }
                    //---
                    if ((sortBy === 'date') || (sortBy === 'compdate')) {
                        A = moment(A).format('x');
                        B = moment(B).format('x');
                    }

                    if (sortBy === 'dow') {
                        A = weekdaysShort.indexOf(A);
                        B = weekdaysShort.indexOf(B);
                    }

                    if (order === 'asc') {
                        return A - B;
                    }

                    if (order === 'desc') {
                        return B - A;
                    }
                }
            });
            return arr_copy;
        }

        // let sortedTotal = arraySort(tempSortedDatesTotal);
        // let sortedSegment = arraySort(tempSortedDates);
        // tempSortedDates.sort((a, b) => {
        //     if (sortedParentIndex !== null) {
        //         let A = a[sortedParentIndex][sortBy];
        //         let B = b[sortedParentIndex][sortBy];
        //         //This is added for Pickup variance to sdly column
        //         A = (A) ? A : 0;
        //         B = (B) ? B : 0;

        //         if (typeof A !== 'number' && A.indexOf('%') !== -1) {
        //             A = Number(A.replaceAll(/%/g, ''));
        //         }
        //         if (typeof B !== 'number' && B.indexOf('%') !== -1) {
        //             B = Number(B.replaceAll(/%/g, ''));
        //         }
        //         //---
        //         if ((sortBy === 'date') || (sortBy === 'compdate')) {
        //             A = moment(A).format('x');
        //             B = moment(B).format('x');
        //         }

        //         if (sortBy === 'dow') {
        //             A = weekdaysShort.indexOf(A);
        //             B = weekdaysShort.indexOf(B);
        //         }

        //         if (order === 'asc') {
        //             return A - B;
        //         }

        //         if (order === 'desc') {
        //             return B - A;
        //         }
        //     }
        // });

        if (workspace_controls.segmented_view) {
            tempSortedDatesTotal.map((item, i) => {
                if (!sortedDates.includes(item[0][dba_date])) {
                    sortedDates.push(item[0][dba_date]);
                    let dateFilter = tempSortedDates.filter((d) => d[0][dba_date] === item[0][dba_date] && d[0].segment !== 'Total');
                    let dateFilterTotal = tempSortedDatesTotal.filter((d) => d[0][dba_date] === item[0][dba_date] && d[0].segment === 'Total');
                    dateFilter = arraySort(dateFilter);
                    // debugger;
                    finalSortedData = [...finalSortedData, ...dateFilter, ...dateFilterTotal];
                }
            });
            finalSortedData = [...finalSortedData, ...tempSortedDatesBlank];
        } else {
            finalSortedData = tempSortedDates;
        }

    }
    return finalSortedData;
}

const getSortedColumn = (columns) => {
    //Get sorted column details from column configuration
    let sortedColumn = {};
    columns.map((main, i) => {
        main.subcolumns.map((sub, j) => {
            //it depends on property sorted
            if (sub.sorted) {
                sortedColumn = sub;
            }
        });
    });
    return sortedColumn;
};

const getFilteredColumns = (columns) => {
    //Get filter column details from column configuration
    let filteredColumns = [];
    columns.map((main, i) => {
        let subcols = main.subcolumns;
        for (let j = 0; j < subcols.length; j++) {
            let sub = subcols[j];
            if (sub.filterable && sub.filter && (sub.filter.gte || sub.filter.lte)) {
                filteredColumns.push(sub);
            }
        }
    });
    // debugger;
    return filteredColumns;
};
//Helper components
const ColumnSorting = (props) => {
    const { colItem, sortable, onOrderByChange, sorted, label, value } = props;

    const onClickHandler = (ev) => {
        // debugger;
        if (!sorted) {
            colItem.sorted = 'asc';
        }
        if (sorted === 'asc') {
            colItem.sorted = 'desc';
        }
        if (sorted === 'desc') {
            colItem.sorted = null;
        }
        onOrderByChange(colItem);
    }

    if (!sortable) {
        return (<></>);
    }
    return (
        <div style={{ position: 'relative' }}>
            <Tooltip title={"Sort by " + label} arrow>
                <Button className={props.className + ' order-' + colItem.sorted} onClick={onClickHandler}>
                    <ArrowDropUpIcon className='order-arrow order-arrow-up' />
                    <ArrowDropDownIcon className='order-arrow order-arrow-down' />
                </Button>
            </Tooltip>

        </div>

    );
}